import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { GetQCJobDataByJobId } from "../Services/PreviewChecklistDataService";
import { DetailsList, CheckboxVisibility } from '@fluentui/react/lib/DetailsList';
import { processAndUpdateToken, findTableForIndex, findTblRowAllIndex, filterSelectedRowIndexForCopyPaste, getText, updateAllSheetsResultArray } from '../Services/CommonFunctions';
import { GetFileName, GetLobDetailsForQuoteCompare } from "../Services/QuoteCompareService"
import { DiscrepancyOptionsDialogComponent, CsrQcEndorsementDialogComponent, FilterCsrDialogComponent } from '../Services/dialogComponent';
import { SimpleSnackbar } from '../Components/SnackBar';
import { Icon } from '@fluentui/react';
import { getEmptyDataSet } from '../Services/CommonFunctions';
import { GetTbl1Data, UpdateQcStatusCall } from "../Services/QuoteCompareService";
import { baseUrl, Disclaimer, discliamerIndex } from "../Services/Constants";
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import $ from 'jquery';
import '../App.css';

export default function QCNoneditable(props) {
    const container = useRef();
    const [reviewData, setReviewData] = useState([]);
    const [sendPolicyInsuredData, setSendPolicyInsuredData] = useState([]);
    const [csrQcDataForSave, setDataForSavePolicy] = useState([]);
    const [dataForXRayMapping, setDataForXRayMapping] = useState([]);
    const [dataForSaveCsrQcPosition, setDataForSaveCsrQcPosition] = useState([]);
    const [yesQcDialog, setYesQcDialog] = useState(false);
    const [dropDialog, setDropDialog] = useState(false);
    const [saveFlag, setSaveFlag] = useState(false);
    const [sheetState, setsheetState] = useState([]);
    const [lobResult, setLobResult] = useState([]);
    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const [filterSelectionData, setFilterSelectionData] = useState(null);
    const [files, setFiles] = useState([]);
    const [activeSheetName, setActiveSheetName] = useState("");
    const [showFilter, setShowFilter] = useState(false);
    const [selctedTableData, setSelctedTableData] = useState([]);
    const [loBResult1, setLobResult1] = useState([]);
    const [QctableColumnDetails, setQcTableColumnDetails] = useState({ "Table 1": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 2": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 3": { "columnNames": {}, "range": { "start": "", "end": "" } }, "Table 4": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const [proposaltableColumnDetails, setProposalTableColumnDetails] = useState({ "PTable 1": { "columnNames": {}, "range": { "start": "", "end": "" } }, "PTable 2": { "columnNames": {}, "range": { "start": "", "end": "" } }, "PTable 3": { "columnNames": {}, "range": { "start": "", "end": "" } }, "PTable 4": { "columnNames": {}, "range": { "start": "", "end": "" } }, "PTable 5": { "columnNames": {}, "range": { "start": "", "end": "" } } });
    const value = 9;
    const header = 10;
    const luckysheet = window.luckysheet;
    const luckysheetRef = useRef(null);
    let token = sessionStorage.getItem('token');
    let url = new URL(window.location.href);
    let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
    const lobData = sessionStorage.setItem('lob', JSON.stringify(props?.lob || ""));

    const apiDataConfig = {
        demo: {
            name: JSON.parse(sessionStorage.getItem('lob')),
            color: "",
            ff: "\"Tahoma\"",
            config: {
                merge: {
                    "0_1": {
                        "rs": 1,
                        "cs": 6,
                        "r": 0,
                        "c": 1
                    },
                    "1_1": {
                        "rs": 1,
                        "cs": 1,
                        "r": 0,
                        "c": 1
                    },
                },
                borderInfo: [],
                rowlen: {
                },
                columnlen: {
                    "1": 300,
                    "2": 300,
                    "3": 300,
                    "4": 300,
                    "5": 300,
                    "6": 300,
                    "7": 300,
                    "8": 300,
                    "9": 300,
                    "10": 300,
                    "11": 300,
                    "12": 300,
                    "13": 300,
                    "14": 300
                },
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },
            chart: [],
            status: "1",
            order: "0",
            hide: 0,
            column: 50,
            row: 50,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: []
        }
    };

    const generateProposalDataConfig = {
        demo: {
            name: "Proposal",
            color: "",
            ff: "\"Tahoma\"",
            config: {
                merge: {
                    "0_1": {
                        "rs": 1,
                        "cs": 6,
                        "r": 0,
                        "c": 1
                    },
                    "1_1": {
                        "rs": 1,
                        "cs": 1,
                        "r": 0,
                        "c": 1
                    },
                },
                borderInfo: [],
                rowlen: {
                },
                columnlen: {
                    "1": 300,
                    "2": 300,
                    "3": 300,
                    "4": 300,
                    "5": 300,
                    "6": 300,
                    "7": 300,
                    "8": 300,
                    "9": 300,
                    "10": 300,
                    "11": 300,
                    "12": 300,
                    "13": 300,
                    "14": 300
                },
                "curentsheetView": "viewPage",
                "sheetViewZoom": {
                    "viewNormalZoomScale": 0.6,
                    "viewPageZoomScale": 0.6,
                },
            },
            chart: [],
            status: "1",
            order: "0",
            hide: 0,
            column: 50,
            row: 500,
            celldata: [],
            ch_width: 2322,
            rh_height: 949,
            scrollLeft: 0,
            scrollTop: 0,
            luckysheet_select_save: [],
            calcChain: [],
            luckysheet_alternateformat_save: [],
            luckysheet_alternateformat_save_modelCustom: [],
            sheets: []
        }
    };

    const luckyCss = {
        margin: '0px',
        padding: '0px',
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: '0px',
        top: '0px',
    };
    const isPreviewCompleted = reviewData && reviewData?.ReviewCompleted;
    const isGridspiCompleted = sendPolicyInsuredData && sendPolicyInsuredData?.SendPolicyToInsured;

    let avaliablelobs = [];
    useEffect(() => {
        sessionStorage.removeItem("inputData");
        sessionStorage.removeItem("generateProposalSelectedFiled");

        if (!props?.sheetData || props?.sheetData.length === 0) return;

        let url = new URL(window.location.href);
        let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
        const brokerId = jobId?.slice(0, 4) || 0;

        if (!jobId) {
            for (const [key, value] of url?.searchParams.entries()) {
                if (key.toLowerCase() === "jobid") {
                    jobId = value;
                    break;
                }
            }
        }

        const getTbl1Data = async (brokerId, jobId) => {
            return await GetTbl1Data(brokerId, jobId);
        }

        const getJobFiles = async (jobId) => {
            const fileName = await GetFileName(jobId);

            return fileName;
        }

        const renderDisclaimer = () => {
            const textBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#ff0000",
                    ff: "\"Tahoma\"",
                    m: Disclaimer,
                    v: Disclaimer,
                },
            ];

            return textBlock;
        };

        const renderList = () => {
            const listBlock = [
                {
                    ct: {
                        fa: "General",
                        t: "g"
                    },
                    fc: "#000000",
                    ff: "\"Tahoma\"",
                    m: JSON.parse(sessionStorage.getItem('lob')),
                    v: JSON.parse(sessionStorage.getItem('lob')),
                },
            ];

            return listBlock;
        };

        const fetchDataAndRender = async () => {
            try {
                const api_data = props?.sheetData;
                const rawQuoteFiles = await getJobFiles(jobId);
                let quoteFiles = rawQuoteFiles;
                // Apply only for this JobId
                if (jobId === "1176Gen20260331072314762679QC") {
                    quoteFiles = rawQuoteFiles?.map(f =>
                        f.includes("$") ? "'" + f : f
                    );
                }
                quoteFiles = rawQuoteFiles?.map(f => f.includes("$") ? "'" + f : f);
                // Apply same pattern as QCDataRenderer: prepend "'" to file names that contain "$"
                setFiles(quoteFiles);

                const groupByGroupIdAndQuestion = (records) => {
                    const groupId = {}
                    records?.forEach((obj) => {
                        const key = `${obj?.GroupId}-${obj?.ChecklistQuestion}`;
                        if (!groupId[key]) groupId[key] = [];
                        groupId[key].push(obj);
                    });
                    return groupId
                }

                const structureTblData = (group) => {
                    if (group?.length <= 1) return;

                    const result = {}

                    result["Id"] = group[0]["Id"];
                    result["CoverageSpecification"] = group[0]["CoverageSpecification"]
                    result["ChecklistQuestion"] = group[0]["ChecklistQuestion"]
                    result["PolicyLob"] = group[0]["PolicyLob"]

                    const matchScores = group.map(i => i.MatchScore);
                    const extractedVals = group.map(i => i.ExtractedValue);

                    if (matchScores.every(s => s === 100)) {
                        result.Status = "Matched";
                    } else if (extractedVals.every(v => v === "Details not available in the document")) {
                        result.Status = "Details not available";
                    } else {
                        result.Status = "Mismatch";
                    }

                    group?.forEach(item => {
                        const pageNo = item?.PageNum;

                        let fileKey =
                            quoteFiles?.find(qf =>
                                (qf.startsWith("'")
                                    ? qf.substring(1)
                                    : qf) === item.DocumentName
                            ) || item.DocumentName;

                        // Special job handling
                        if (jobId === "1176Gen20260331072314762679QC") {
                            fileKey = fileKey.startsWith("'")
                                ? fileKey
                                : `'${fileKey}`;
                        }

                        result[fileKey] =
                            item.ExtractedValue ===
                            "Details not available in the document"
                                ? item.ExtractedValue
                                : item.ExtractedValue +
                                " ~~Page # " +
                                (pageNo === null ? "" : pageNo);
                    });

                    let DNA_rowitemscheck = group?.every(e => e?.ExtractedValue === "Details not available in the document");

                    result["DocumentViewer"] = group[0]["MatchScore"] === 100 || DNA_rowitemscheck ? "" : group[0]["DocumentViewer"]
                    result["ActionOnDiscrepancy"] = group[0]["ActionOnDiscrepancy"] || ''
                    result["RequestEndorsement"] = group[0]["RequestEndorsement"] || ''
                    result["Notes"] = group[0]["Notes"] || ''
                    result["NotesFreeFill"] = group[0]["NotesFreeFill"] || ''
                    return result;
                };

                const processData = (tblObj) => {
                    const matchedOnly = [];
                    const DNAOnly = [];
                    const variancesOnly = [];
                    const variancesDatas = [];
                    // Strip leading "'" to get the raw DocumentName (with "$") for matching against API data
                    let groupDataByGid = [];

                    const tblData = tblObj?.map(item => {
                        let documentName = item?.DocumentName;

                        if (
                            jobId?.toString() ===
                            "1176Gen20260331072314762679QC"
                        ) {
                            documentName = documentName?.startsWith("'")
                                ? documentName
                                : `'${documentName}`;
                        }

                        return {
                            ...item,
                            DocumentName: documentName
                        };
                    });

                    groupDataByGid = groupByGroupIdAndQuestion(tblData);
                    const QFiles = quoteFiles?.map((item) => item.startsWith("'") ? item.substring(1) : item);

                    // Strip leading "'" from quoteFiles for DocumentName lookup (API returns names with "$", without "'")
                    // const QFiles = quoteFiles.map((item) => item.startsWith("'") ? item.substring(1) : item);
                    
                    for (const key in groupDataByGid) {
                        const group = groupDataByGid[key];
                        if (!group) continue;

                        // Check if all documents are present in quoteFiles
                        let allFilesPresent = group?.every(f => {
                            const documentName =
                                f?.DocumentName?.startsWith("'")
                                    ? f.DocumentName.substring(1)
                                    : f.DocumentName;

                            return QFiles?.includes(documentName);
                        });

                        if (!allFilesPresent) continue;

                        const matchScores = group.map(f => f?.MatchScore);
                        const extractedValues = group.map(f => f?.ExtractedValue);

                        const row = structureTblData(group);
                        if (!row) continue;

                        // //case : 1 All Matchscore == 0  and containes atleat one variances
                        // if ((matchScores?.every(score => score === 0)) && (extractedValues?.some(val => val && val?.toLowerCase() !== "details not available in the document"))) {
                        //     variancesOnly.push(row)
                        // }

                        // //case : 2 All Matchscore == 100
                        // if (matchScores?.every(score => score === 100)) {
                        //     matchedOnly.push(row);
                        // }

                        // //case : 3 All Extractedvalue is 'DNA records'
                        // if (extractedValues?.every(val => val?.toLowerCase() === "details not available in the document")) {
                        //     DNAOnly.push(row);
                        // }
                        variancesDatas.push(row)
                    }
                    return variancesDatas
                };

                const tbl1Data = await getTbl1Data(brokerId, jobId);
                let tbl1StructuredData = Object.keys(tbl1Data)?.map((key, index) => ({
                    HeaderID: index + 1,
                    Headers: key,
                    "": tbl1Data[key]
                }));

                let term_Val = api_data?.CommonDeclaration?.filter(file => file?.IsBaseDocument && file.CoverageSpecification == "Term");
                if (term_Val?.length > 0 && term_Val[0]?.ExtractedValue != "Details not available in the document") {
                    term_Val = term_Val[0]?.ExtractedValue;
                } else {
                    term_Val = "";
                }

                const Qctable1Data = [];
                const additionalEntries = [
                    {
                        HeaderID: 1,
                        Headers: "Named Insured",
                        "": tbl1StructuredData?.find(item => item.Headers === "ClientName")?.[""] || ""
                    },
                    {
                        HeaderID: 2,
                        Headers: "Term",
                        "": term_Val
                    },
                    {
                        HeaderID: 3,
                        Headers: "LOB",
                        "": JSON.parse(sessionStorage.getItem('lob')),
                    },
                    {
                        HeaderID: 4,
                        Headers: "Account Manager",
                        "": ""
                    },
                    {
                        HeaderID: 5,
                        Headers: "UpdatedOn",
                        "": new Date(tbl1StructuredData?.find(item => item.Headers === "UpdatedOn")?.[""]).toLocaleDateString() || ""
                    },
                  {
                        HeaderID: 6,
                        Headers: "Documents used for Quote Compare",

                        "": jobId?.toString() ===
                            "1176Gen20260331072314762679QC"

                            ? quoteFiles
                                ?.map(f =>
                                    (f.startsWith("'")
                                        ? f.substring(1)
                                        : f
                                    ).replace(/\$/g, "")
                                )
                                ?.join(', ')

                            : quoteFiles?.map((f) => (f.startsWith("'") ? f.substring(1) : f).replace(/\$/g, ""))?.join(', ')
                    }
                ];

                Qctable1Data.push(...additionalEntries);

                const cdTable = processData(api_data?.CommonDeclaration);
                const covTable = processData(api_data?.Coverages);
                const formsTable = processData(api_data?.Forms);

                let apiData = [
                    {
                        "Tablename": "Table 1",
                        "TemplateData": Qctable1Data
                    },
                    {
                        "Tablename": "Table 2",
                        "TemplateData": [...cdTable]
                    }
                    // {
                    //     "Tablename":`Table 3`,
                    //     "TemplateData": [...covTable]
                    // }
                ];

                if (!tbl1Data?.IsMultipleLobSplit) {
                    apiData.push({
                        Tablename: `Table 3`,
                        TemplateData: [...covTable]
                    });
                }

                if (tbl1Data?.IsMultipleLobSplit) {
                    const lobs = Object?.keys(api_data?.LobSplitCoverages);
                    lobs.forEach((lob) => {
                        const records = processData(api_data?.LobSplitCoverages?.[lob]);
                        apiData.push({
                            "Tablename": `Table ${apiData.length+1}`,
                            "TemplateData": [...records]
                        });
                    });
                }
                apiData.push({
                    Tablename: `Table ${apiData.length+1}`,
                    TemplateData: [...formsTable]
                });

                // if (covTable?.length > 0 && covTable[0]?.PolicyLob) {
                //     avaliablelobs.push(covTable[0].PolicyLob);
                // }

                if (tbl1Data?.IsMultipleLobSplit && api_data?.LobSplitCoverages) {
                    Object.keys(api_data.LobSplitCoverages).forEach((lob) => {
                        const firstRecord = api_data.LobSplitCoverages[lob]?.[0];

                        if (firstRecord?.PolicyLob) {
                            avaliablelobs.push(firstRecord.PolicyLob);
                        }
                    });
                }

                avaliablelobs = [...new Set(avaliablelobs)];

                const templateData = apiData?.filter(array => array?.TemplateData?.length !== 0);

                const inputData = templateData;
                sessionStorage.setItem('inputData', JSON.stringify(inputData));

                const renderCsrQcTable1 = () => {
                    const tableData1 = inputData?.find((data) => data.Tablename === "Table 1");
                    if (tableData1) {
                        const table1json = tableData1.TemplateData;

                        let table1Array = [];
                        let sheetDataTable2 = [];
                        const rowIndexOfTable1 = 3;
                        const textBlockData = renderDisclaimer();
                        const listData = renderList();
                        const dummyData = [];

                        textBlockData.forEach((item, index) => {
                            const mergeConfig = apiDataConfig.demo.config.merge["0_1"];

                            sheetDataTable2.push({
                                r: index + mergeConfig.r,
                                c: mergeConfig.c,
                                v: {
                                    ct: item.ct,
                                    m: item.m,
                                    v: item.v,
                                    bl: 1,
                                    fs: 8.5,
                                    ff: item.ff,
                                    merge: mergeConfig,
                                    fc: item.fc,
                                    // tb: '55',
                                }
                            });
                        });

                        listData.forEach((item, index) => {
                            const mergeConfig = apiDataConfig.demo.config.merge["1_1"];

                            sheetDataTable2.push({
                                r: 1 + mergeConfig.r,
                                c: mergeConfig.c,
                                v: {
                                    ct: item.ct,
                                    m: item.m,
                                    v: item.v,
                                    ff: item.ff,
                                    fs: 13,
                                    merge: mergeConfig,
                                    fc: item.fc,
                                }
                            });
                        });

                        table1json.map((item, index) => {
                            if (item["Headers"] != null) {
                                table1Array.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma", bl: .5 }] },
                                        m: item["Headers"],
                                        v: item["Headers"],
                                        ff: "Tahoma",
                                        fs: `${header}`,
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });

                                const tidleValue = item[""] !== null ? item[""]?.replace(/~~/g, "\n") : "";

                                table1Array.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: `${value}`,
                                        ff: "\"Tahoma\"",
                                        merge: null,
                                        tb: '2',
                                    }
                                });

                                let maxLength = 0;
                                const lengths = [];
                                Object.keys(item).forEach((key) => {
                                    if (item[key]) {
                                        lengths.push(item[key]?.length);
                                    }
                                });
                                lengths.forEach((length) => {
                                    if (length > maxLength) {
                                        maxLength = length;
                                    }
                                });
                                const rowHeight = parseInt(maxLength / 3 + 15);
                                apiDataConfig.demo.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;
                            }
                        });

                        const matchedUnMatchedFilter = [
                            {
                                "r": 3,
                                "c": 4,
                                "v": {
                                    "ct": {
                                        "fa": "General",
                                        "t": "inlineStr",
                                        "s": [
                                            {
                                                "fs": "16",
                                                "v": "",
                                                "un": 1
                                            },
                                            {
                                                "vt": "0",
                                                "ht": 0,
                                                "fs": "9",
                                                "un": 1,
                                                "bl": 1,
                                                "fc": "#56a9d3e6",
                                                "ff": "\"Tahoma\"",
                                                "m": "Generate Summary for Proposal",
                                                "v": "Generate Summary for Proposal"
                                            }
                                        ]
                                    },
                                    "merge": null,
                                    "w": 55,
                                    "tb": "2",
                                    "fc": "#56a9d3e6",
                                    "fs": "16",
                                    "un": 1
                                }
                            },
                            // {
                            //     "r": 4,
                            //     "c": 4,
                            //     "v": {
                            //         "ct": {
                            //             "fa": "General",
                            //             "t": "inlineStr",
                            //             "s": [
                            //                 {
                            //                     "fs": "16",
                            //                     "v": "□ "
                            //                 },
                            //                 {
                            //                     "vt": "0",
                            //                     "ht": "1",
                            //                     "fs": "9",
                            //                     "un": 0,
                            //                     "bl": 1,
                            //                     "fc": "#0000ff",
                            //                     "ff": "\"Tahoma\"",
                            //                     "m": "Matched",
                            //                     "v": "Matched"
                            //                 }
                            //             ]
                            //         },
                            //         "merge": null,
                            //         "w": 55,
                            //         "tb": "2",
                            //         "fc": "#0000ff",
                            //         "fs": "16"
                            //     }
                            // },
                            // {
                            //     "r": 5,
                            //     "c": 4,
                            //     "v": {
                            //         "ct": {
                            //             "fa": "General",
                            //             "t": "inlineStr",
                            //             "s": [
                            //                 {
                            //                     "fs": "16",
                            //                     "v": "□ "
                            //                 },
                            //                 {
                            //                     "vt": "0",
                            //                     "ht": "1",
                            //                     "fs": "9",
                            //                     "un": 0,
                            //                     "bl": 1,
                            //                     "fc": "#0000ff",
                            //                     "ff": "\"Tahoma\"",
                            //                     "m": "Mismatch",
                            //                     "v": "Mismatch"
                            //                 }
                            //             ]
                            //         },
                            //         "merge": null,
                            //         "w": 55,
                            //         "tb": "2",
                            //         "fc": "#0000ff",
                            //         "fs": "16"
                            //     }
                            // },
                            // {
                            //     "r": 6,
                            //     "c": 4,
                            //     "v": {
                            //         "ct": {
                            //             "fa": "General",
                            //             "t": "inlineStr",
                            //             "s": [
                            //                 {
                            //                     "fs": "16",
                            //                     "v": "□ "
                            //                 },
                            //                 {
                            //                     "vt": "0",
                            //                     "ht": "1",
                            //                     "fs": "9",
                            //                     "un": 0,
                            //                     "bl": 1,
                            //                     "fc": "#0000ff",
                            //                     "ff": "\"Tahoma\"",
                            //                     "m": "Details not available",
                            //                     "v": "Details not available"
                            //                 }
                            //             ]
                            //         },
                            //         "merge": null,
                            //         "w": 55,
                            //         "tb": "2",
                            //         "fc": "#0000ff",
                            //         "fs": "16"
                            //     }
                            // },
                        ];

                        const allRows = [...table1Array, ...matchedUnMatchedFilter, ...sheetDataTable2];

                        const QctableColumnDetails1 = QctableColumnDetails;
                        QctableColumnDetails1["Table 1"] = { "columnNames": table1json.map((e) => e?.Headers), "range": { "start": 0, "end": table1Array[table1Array?.length - 1]?.r } }
                        setQcTableColumnDetails(QctableColumnDetails1);

                        allRows.sort((a, b) => a.r - b.r);

                        dummyData.push(...allRows);
                        apiDataConfig.demo.celldata = dummyData;

                        apiDataConfig.demo.config.borderInfo.push({
                            "rangeType": "range",
                            "borderType": "border-all",
                            "color": "#000",
                            "style": "1",
                            "range": [
                                {
                                    "left": 857,
                                    "width": 250,
                                    "top": 114,
                                    "height": 50,
                                    "left_move": 857,
                                    "width_move": 250,
                                    "top_move": 114,
                                    "height_move": 122,
                                    "row": [
                                        3,
                                        3
                                    ],
                                    "column": [
                                        4,
                                        4
                                    ],
                                    "row_focus": 4,
                                    "column_focus": 4
                                }
                            ]
                        });

                        allRows.forEach((row) => {
                            if (table1Array.includes(row)) {
                                apiDataConfig.demo.config.borderInfo.push({
                                    "rangeType": "cell",
                                    "value": {
                                        "row_index": row?.r,
                                        "col_index": row?.c,
                                        "l": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "r": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "t": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "b": {
                                            "style": 1,
                                            "color": "#000"
                                        }
                                    }
                                });
                            }
                        });

                        let csrQcDataTracked = [];
                        let positioningForCsrQc = [];
                        let xRAyCsrQcDataMap = [];
                        inputData?.map((e, index) => {
                            if (e?.Tablename != 'Table 1' && e?.TemplateData?.length >= 1) {
                                let filteredData = apiDataConfig.demo.celldata.filter((f, index) => f != null || !f);
                                renderCsrQcTable2([...filteredData], e?.Tablename);
                                const trackedData = renderCsrQcTable2([...filteredData], e?.Tablename);
                                csrQcDataTracked = [...csrQcDataTracked, ...trackedData?.dataForReturn];
                                positioningForCsrQc = [...positioningForCsrQc, ...trackedData?.QctableColumnDetailsForPolicySave];
                                xRAyCsrQcDataMap = [...xRAyCsrQcDataMap, ...trackedData?.QctableColumnDetailsForXRay];
                            }
                            if (inputData?.length === (index + 1)) {
                                const reseed_csrQcDataTracked = csrQcDataTracked?.map((item,i) => {
                                    return{
                                        ...item,
                                        TableName: `Table ${i + 2}`
                                    }
                                });
                                setDataForSavePolicy(reseed_csrQcDataTracked);
                                sessionStorage.setItem('csrQcDataTracked', JSON.stringify(reseed_csrQcDataTracked))
                                const reseed_positioningForCsrQc = positioningForCsrQc?.map((item,i) => {
                                    return{
                                        ...item,
                                        TableName: `Table ${i + 2}`
                                    }
                                });
                                setDataForSaveCsrQcPosition(reseed_positioningForCsrQc);
                                sessionStorage.setItem('positioningForCsrQc', JSON.stringify(reseed_positioningForCsrQc))
                                const reseed_xRAyCsrQcDataMap = xRAyCsrQcDataMap?.map((item,i) => {
                                    return{
                                        ...item,
                                        TableName: `Table ${i + 2}`
                                    }
                                });
                                setDataForXRayMapping(reseed_xRAyCsrQcDataMap);
                            }
                        });
                    }
                };

                const renderCsrQcTable2 = (combinedata1, tableName) => {
                    if (!Array.isArray(combinedata1)) {
                        console.error("combinedata1 is not an array:", combinedata1);
                        return;
                    }
                    const QctableColumnNamesOfValid = {};

                    const DefaultColumns = ["Actions on Discrepancy (from AMs)", "ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];

                    const basedata = [...combinedata1];

                    const tableData2 = inputData?.find((data) => data.Tablename === tableName);
                    if (!tableData2) {
                        console.error("Table 2 data not found");
                        return;
                    }

                    const table2json = tableData2.TemplateData;

                    const policyLOBValuesForLobSplit = table2json?.filter(item =>
                        avaliablelobs.includes(item["POLICY LOB"] || item["PolicyLob"])
                    );

                    if (policyLOBValuesForLobSplit && policyLOBValuesForLobSplit?.length > 0) {
                        tableName = 'Table 3';
                    }

                    const table2jsoncopy = table2json.map(item => {
                        const {
                            Id,
                            ChecklistQuestion,
                            sheetPosition,
                            PolicyLob,
                            Status,
                            ...filteredItem
                        } = item;
                        return filteredItem;

                    });

                    let headers = Object.keys(table2jsoncopy[0]);

                    const startIndex =
                        headers?.indexOf("CoverageSpecification");

                    const endIndex =
                        headers?.indexOf("DocumentViewer");

                    const fileHeaders =
                        headers?.slice(startIndex + 1, endIndex);

                    const orderedFileHeaders =
                        quoteFiles?.filter(file =>
                            fileHeaders?.includes(file)
                        );

                    headers = [
                        ...headers?.slice(0, startIndex + 1),
                        ...orderedFileHeaders,
                        ...headers?.slice(endIndex)
                    ];

                    headers = headers?.filter(f => !["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"]?.includes(f));
                    const value = Object?.values(table2json);

                    let policyLOBValues = value?.map(item => item["POLICY LOB"] || item["PolicyLob"]);

                    if(policyLOBValues[0] == null) {
                        policyLOBValues = JSON.parse(sessionStorage.getItem('lob'));
                    } 

                    let finalPolicyLOB = Array.isArray(policyLOBValues) ? policyLOBValues[0] : policyLOBValues;

                    let headerRows1 = [];
                    let rowIndexForLOBStart = 0;
                    let rowIndexForLOBEnd = 0;

                    if (tableName === "Table 3") {
                        rowIndexForLOBStart = basedata[basedata?.length - 1]?.r + 2;
                        headerRows1 = [
                            {
                                r: basedata[basedata?.length - 1]?.r + 2,
                                rs: 1,
                                c: 1,
                                cs: headers.length + 1,
                                v: {
                                    ct: { fa: "General", t: "g" },
                                    m:  finalPolicyLOB,
                                    v: finalPolicyLOB,
                                    fs: `${header}`,
                                    ff: "\"Tahoma\"",
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    s: [{ bl: 1 }],
                                    w: 55,
                                }
                            }
                        ]
                    };

                    const removalCode = headers?.map(item => {
                        if (item === "CoverageSpecification") {
                            if (tableName === "Table 2") {
                                return "Common Declarations";
                            }

                            if (inputData[inputData?.length -1]?.Tablename === tableName) {
                                return "Forms Listed";
                            }


                            return "Coverage Specifications";
                        }

                        if (item === "DocumentViewer") {
                            return "Document Viewer";
                        }

                        return item;
                    });

                    headerRows1 = [
                        ...headerRows1,
                        ...removalCode?.map((item, index) => {
                            if (index === 0) {
                                apiDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2}_${index}`] = {
                                    "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 2 : basedata[basedata?.length - 1]?.r + 2,
                                    "c": index,
                                    "rs": tableName === "Table 3" ? 3 : 2,
                                    "cs": 1
                                }
                            }
                            apiDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2}_${1 + index}`] = {
                                "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                                "c": 1 + index,
                                "rs": 2,
                                "cs": 1
                            }
                            // apiDataConfig.demo.config.merge[`${basedata[basedata?.length - 1]?.r + 3}_${1 + index}`] = {
                            //     "r": basedata[basedata?.length - 1]?.r + 3,
                            //     "c": 1 + index,
                            //     "rs": 2,
                            //     "cs": 1
                            // }

                            return {
                                r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                                rs: 2,
                                c: 1 + index,
                                cs: 1,
                                v: {
                                    ct: { fa: "General", t: "g" },
                                    ff: "\"Tahoma\"",
                                    m: item,
                                    v: item,
                                    merge: null,
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    w: 55,
                                    fs: `${header}`
                                }
                            }
                        })
                    ];

                    if (headerRows1?.length > 0) {
                        headerRows1.forEach((f, index) => {
                            if (tableName === "Table 2" && (index === 0)) {
                                QctableColumnNamesOfValid["CoverageSpecification"] = f?.c;
                                // }
                                //  else if (index === 0) {
                                //     QctableColumnNamesOfValid["CoverageSpecification"] = f?.c;
                            } else {
                                QctableColumnNamesOfValid[f?.v?.v] = f?.c;
                            }
                        });
                    }

                    headerRows1 = [...headerRows1];

                    const defaultHeaderRows1 = DefaultColumns?.map((item, index) => {
                        if (DefaultColumns?.length === index + 1) {
                            rowIndexForLOBEnd = tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index;
                        }
                        if (index == 0) {
                            apiDataConfig.demo.config.merge[`${tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2}_${tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1}`] = {
                                "r": tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                                "c": tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1,
                                "rs": 1,
                                "cs": 4
                            }
                            return {
                                r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 2,
                                rs: 1,
                                c: tableName === "Table 3" ? headerRows1.length + index : headerRows1.length + index + 1,
                                cs: 1,
                                v: {
                                    ht: 0,
                                    ct: { fa: "General", t: "g" },
                                    ff: "\"Tahoma\"",
                                    m: item,
                                    v: item,
                                    merge: null,
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    w: 55,
                                    fs: `${header}`
                                }
                            }
                        }
                        else {
                            return {
                                r: tableName === "Table 3" ? basedata[basedata?.length - 1]?.r + 4 : basedata[basedata?.length - 1]?.r + 3,
                                rs: 1,
                                c: tableName === "Table 3" ? headerRows1.length + index - 1 : headerRows1.length + index,
                                cs: 1,
                                v: {
                                    ct: { fa: "General", t: "g" },
                                    ff: "\"Tahoma\"",
                                    m: item,
                                    v: item,
                                    merge: null,
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    w: 55,
                                    fs: `${header}`
                                }
                            }
                        }
                    });

                   if (tableName === "Table 3") {
                        apiDataConfig.demo.config.merge[`${rowIndexForLOBStart}_${1}`] = {
                            "r": rowIndexForLOBStart,
                            "c": 1,
                            "rs": 1,
                            "cs": rowIndexForLOBEnd - 1,
                        }
                    }

                    let headerRows1Values = [];

                    let rowIndex = defaultHeaderRows1[defaultHeaderRows1.length - 1]?.r + 1;
                    let actionColumnKeys;

                    actionColumnKeys = ["ActionOnDiscrepancy", "RequestEndorsement", "Notes", "NotesFreeFill"];
                    headers = [...headers, ...actionColumnKeys];

                    let dataToUpDate = table2json?.map((item, cIndex) => {
                        let rowIndexForStateData = 0;

                        let rowHeight = 41;
                        headers.map((key, rIndex) => {
                            rowIndex = headerRows1Values?.length == 0 ? rowIndex : headerRows1Values?.length > 0 && rIndex == 0 ? headerRows1Values[headerRows1Values.length - 1]?.r + 1 : headerRows1Values[headerRows1Values.length - 1]?.r;
                            rowIndexForStateData = rowIndex;
                            let text = item[key]?.toString()?.split('~~');
                            if (text?.length === 2 && text[0]?.trim() === "" && text[1]?.trim() === "Page #") {
                                text = ["Details not available in the document"];
                            }

                            let ss = [];
                            if (key !== 'DocumentViewer' && text && text?.length > 0) {
                                text?.map((e) => {
                                    if (e?.toLowerCase().includes('page')) {
                                        ss.push({
                                            "ff": "\"Tahoma\"",
                                            "fc": "rgb(68, 114, 196)",
                                            "fs": `${value}`,
                                            "cl": 0,
                                            "un": 0,
                                            "bl": 1,
                                            "it": 0,
                                            "v": e.trim() + "\r\n"
                                        });
                                    } else {
                                        ss.push({
                                            "ff": "\"Tahoma\"",
                                            "fc": "#000000",
                                            "fs": `${value}`,
                                            "cl": 0,
                                            "un": 0,
                                            "bl": 0,
                                            "it": 0,
                                            "v": e.trim() + "\r\n"
                                        });
                                    }
                                })
                            };

                            if (key === 'DocumentViewer') {
                                const dvData = item.Status === "Matched" ? "" : item[key];
                                if (dvData != undefined && dvData != null && dvData?.trim() != '') {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "rgb(61, 133, 198)",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "ht": "0",
                                        "un": 1,
                                        "v": "X-Ray"
                                    });
                                } else {
                                    ss.push({
                                        "ff": "\"Tahoma\"",
                                        "fc": "#000000",
                                        "fs": `${value}`,
                                        "cl": 0,
                                        "un": 0,
                                        "bl": 0,
                                        "it": 0,
                                        "v": "  "
                                    });
                                }
                            }

                            headerRows1Values.push({
                                r: rowIndex,
                                c: rIndex + 1,
                                v: {
                                    ct: { fa: "General", t: "inlineStr", s: ss },
                                    merge: null,
                                    w: 55,
                                    tb: '2',
                                    "ht": key === 'DocumentViewer' ? "0" : key === 'ActionOnDiscrepancy' ? "0" : key === 'RequestEndorsement' ? "0" :
                                        key === 'Notes' ? "0" : null
                                }
                            });
                            if (text && rowHeight < parseInt(item[key]?.length / 3 + 20)) {
                                rowHeight = parseInt(item[key]?.length / 3 + 20);
                                apiDataConfig.demo.config.rowlen[`${rowIndex}`] = rowHeight;
                            }
                            if (rIndex == 0) {
                                apiDataConfig.demo.config.rowlen[`${rowIndex}`] = rowHeight;
                            }
                        })
                        item["sheetPosition"] = rowIndexForStateData;
                        return item;
                    });
                    // dataToUpDate = avaliablelobs?.length > 0
                    //     ? dataToUpDate?.filter((item) => avaliablelobs.includes(item?.PolicyLob))
                    //     : dataToUpDate;

                    const dataForReturn = [{ "TableName": tableName, "data": dataToUpDate }];
                    const xRaydataForReturn = [{ dataToUpDate }];

                    apiDataConfig.demo.config.borderInfo.push({
                        "rangeType": "range",
                        "borderType": "border-top",
                        "color": "#000",
                        "style": "1",
                        "range": [
                            {
                                "left": 1107,
                                "width": 632,
                                "top": 183,
                                "height": 36,
                                "left_move": 1107,
                                "width_move": 632,
                                "top_move": 184,
                                "height_move": 35,
                                "row": [
                                    headerRows1[0]?.r,
                                    headerRows1[0]?.r
                                ],
                                "column": [
                                    defaultHeaderRows1[0]?.c,
                                    defaultHeaderRows1[defaultHeaderRows1?.length - 1]?.c
                                ],
                                "row_focus": headerRows1[0]?.r,
                                "column_focus": defaultHeaderRows1[0]?.c,
                            }
                        ]
                    });


                    apiDataConfig.demo.config.borderInfo.push({
                        "rangeType": "range",
                        "borderType": "border-all",
                        "color": "#000",
                        "style": "1",
                        "range": [
                            {
                                "left": 74,
                                "width": 300,
                                "top": 470,
                                "height": 42,
                                "left_move": 74,
                                "width_move": 4213,
                                "top_move": 471,
                                "height_move": 1107,
                                "row": [
                                    headerRows1[0]?.r,
                                    headerRows1Values[headerRows1Values?.length - 1]?.r
                                ],
                                "column": [
                                    headerRows1[0]?.c,
                                    defaultHeaderRows1[defaultHeaderRows1?.length - 1]?.c
                                ],
                                "row_focus": headerRows1[0]?.r,
                                "column_focus": headerRows1[0]?.c
                            }
                        ]
                    });

                    apiDataConfig.demo.config.borderInfo.push({
                        "rangeType": "range",
                        "borderType": "border-all",
                        "color": "#000",
                        "style": "1",
                        "range": [
                            {
                                "left": 74,
                                "width": 300,
                                "top": 470,
                                "height": 42,
                                "left_move": 74,
                                "width_move": 4213,
                                "top_move": 471,
                                "height_move": 1107,
                                "row": [
                                    headerRows1[0]?.r,
                                    headerRows1[0]?.r + 1
                                ],
                                "column": [
                                    0,
                                    0
                                ],
                                "row_focus": headerRows1[0]?.r,
                                "column_focus": headerRows1[0]?.c
                            }
                        ]
                    });

                    defaultHeaderRows1.forEach(row => {
                        if (row?.v && row?.v?.m && typeof row?.c === 'number' && row.v.m !== 'Actions on Discrepancy (from AMs)') {
                            QctableColumnNamesOfValid[row.v.m] = row?.c;
                        }
                    });

                    let groupingHeader = [];
                    groupingHeader = headerRows1.map((item, index) => {
                        apiDataConfig.demo.config.merge[`${headerRows1[0]?.r}_0`] = {
                            "r": headerRows1[0]?.r,
                            "rs": tableName === "Table 3" ? 3 : 2,
                            "c": 0,
                            "cs": 1
                        }

                        return {
                            r: headerRows1[0]?.r,
                            rs: tableName === "Table 3" ? 3 : 2,
                            c: 0,
                            cs: 1,
                            v: {
                                ct: { fa: "General", t: "g" },
                                ff: "\"Tahoma\"",
                                m: "Grouping",
                                v: "Grouping",
                                merge: null,
                                bg: "rgb(139,173,212)",
                                bl: 0.5,
                                tb: '2',
                                w: 55,
                                fs: `${header}`
                            }
                        }
                    });
                    // const groupingHeader = [{
                    //     "r": headerRows1[0]?.r,
                    //     "rs": tableName == "Table 3" ? 3 : 2,
                    //     "c": 0,
                    //     "cs": 1,
                    //     "v": {
                    //         "ct": {
                    //             "fa": "General",
                    //             "t": "g"
                    //         },
                    //         "m": "Grouping",
                    //         "v": "Grouping",
                    //         "fs": 11,
                    //         "ff": "\"Tahoma\"",
                    //         "merge": null,
                    //         "bg": "rgb(139,173,212)",
                    //         "tb": "2",
                    //         "w": 55
                    //     }
                    // }]

                    headerRows1 = [...headerRows1, ...defaultHeaderRows1, ...headerRows1Values];

                    const allRows2 = [...groupingHeader, ...headerRows1];
                    allRows2.sort((a, b) => a.r - b.r);
                    if (allRows2 && allRows2?.length > 0) {
                        const tableColumnDetailss = QctableColumnDetails;
                        tableColumnDetailss[tableData2?.Tablename] = { "columnNames": QctableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }
                        setQcTableColumnDetails(tableColumnDetailss);
                    }
                    basedata.push(...allRows2);
                    apiDataConfig.demo.celldata = basedata;
                    return {
                        dataForReturn, xRaydataForReturn, QctableColumnDetailsForXRay: [{ "TableName": tableName, "Data": xRaydataForReturn, "columnNames": QctableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }],
                        QctableColumnDetailsForPolicySave: [{ "TableName": tableName, "columnNames": QctableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }]
                    };
                };

                renderCsrQcTable1();

                const renderProposalData1 = (selectedFilesFromDropdown = []) => {
                    const tableData1 = JSON.parse(sessionStorage.getItem('inputData'))?.find((data) => data.Tablename === "Table 1");
                    if (tableData1) {
                        const table1json = tableData1.TemplateData?.slice(0, 3);

                        let table1Array = [];
                        let sheetDataTable2 = [];
                        const rowIndexOfTable1 = 3;
                        const textBlockData = renderDisclaimer();
                        const listData = renderList();
                        const dummyData = [];

                        textBlockData.forEach((item, index) => {
                            const mergeConfig = generateProposalDataConfig.demo.config.merge["0_1"];

                            sheetDataTable2.push({
                                r: index + mergeConfig.r,
                                c: mergeConfig.c,
                                v: {
                                    ct: item.ct,
                                    m: item.m,
                                    v: item.v,
                                    bl: 1,
                                    fs: 8.5,
                                    ff: item.ff,
                                    merge: mergeConfig,
                                    fc: item.fc,
                                }
                            });
                        });

                        listData.forEach((item, index) => {
                            const mergeConfig = generateProposalDataConfig.demo.config.merge["1_1"];

                            sheetDataTable2.push({
                                r: 1 + mergeConfig.r,
                                c: mergeConfig.c,
                                v: {
                                    ct: item.ct,
                                    m: item.m,
                                    v: item.v,
                                    ff: item.ff,
                                    fs: 13,
                                    merge: mergeConfig,
                                    fc: item.fc,
                                }
                            });
                        });

                        table1json.map((item, index) => {
                            if (item["Headers"] != null) {
                                table1Array.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 1,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr", s: [{ v: item["Headers"], ff: "Tahoma", bl: .5 }] },
                                        m: item["Headers"],
                                        v: item["Headers"],
                                        ff: "Tahoma",
                                        fs: `${header}`,
                                        merge: null,
                                        bg: "rgb(139,173,212)",
                                        tb: '2',
                                    }
                                });

                                const tidleValue = item[""] !== null ? item[""]?.replace(/~~/g, "\n") : "";

                                table1Array.push({
                                    r: rowIndexOfTable1 + index,
                                    c: 2,
                                    v: {
                                        ct: { fa: "@", t: "inlineStr" },
                                        m: tidleValue,
                                        v: tidleValue,
                                        fs: `${value}`,
                                        ff: "\"Tahoma\"",
                                        merge: null,
                                        tb: '2',
                                    }
                                });

                                let maxLength = 0;
                                const lengths = [];
                                Object.keys(item).forEach((key) => {
                                    if (item[key]) {
                                        lengths.push(item[key]?.length);
                                    }
                                });
                                lengths.forEach((length) => {
                                    if (length > maxLength) {
                                        maxLength = length;
                                    }
                                });
                                const rowHeight = parseInt(maxLength / 3 + 15);
                                generateProposalDataConfig.demo.config.rowlen[`${rowIndexOfTable1 + index}`] = rowHeight;
                            }
                        });

                        const allRows = [...table1Array, ...sheetDataTable2];
                        allRows.sort((a, b) => a.r - b.r);

                        const proposaltableColumnDetails1 = proposaltableColumnDetails;
                        proposaltableColumnDetails1["PTable 1"] = { "columnNames": table1json.map((e) => e?.Headers), "range": { "start": 0, "end": table1Array[table1Array?.length - 1]?.r } }
                        setProposalTableColumnDetails(proposaltableColumnDetails1);

                        dummyData.push(...allRows);
                        generateProposalDataConfig.demo.celldata = dummyData;

                        allRows.forEach((row) => {
                            if (table1Array.includes(row)) {
                                generateProposalDataConfig.demo.config.borderInfo.push({
                                    "rangeType": "cell",
                                    "value": {
                                        "row_index": row?.r,
                                        "col_index": row?.c,
                                        "l": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "r": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "t": {
                                            "style": 1,
                                            "color": "#000"
                                        },
                                        "b": {
                                            "style": 1,
                                            "color": "#000"
                                        }
                                    }
                                });
                            }
                        });

                        // Call function to filter and append DNA table
                  function filterAndAppendTbl5(inputData) {
                            let table5 = [];

                            inputData?.forEach(table => {
                                if (table?.Tablename != "Table 1") {
                                    const cleanedQuoteFiles = quoteFiles?.map(f => f.replace(/\$/g, ""));
                                    let filterObj = table?.TemplateData?.filter(data => {
                                        return quoteFiles?.every(file => data[file] === "Details not available in the document")
                                    });

                                    if (filterObj?.length > 0) {
                                        filterObj?.forEach(f => {
                                            quoteFiles?.forEach(file => {
                                                if (f[file] === "Details not available in the document") {
                                                    f[file] = "";
                                                }
                                            })
                                        })

                                        table5.push(...filterObj)
                                    }

                                    table.TemplateData = table?.TemplateData?.filter(f => !filterObj.includes(f));
                                }
                            });

                            if (table5?.length > 0) {
                                inputData.push({
                                    Tablename: inputData?.length >= 5 ? `Table ${inputData.length + 1}` : "Table 5",
                                    TemplateData: table5
                                });
                            }

                            return inputData;
                        };

                        let table5Appened = [];
                        if (selectedFilesFromDropdown && selectedFilesFromDropdown?.length > 0) {
                            table5Appened = filterAndAppendTbl5(JSON.parse(sessionStorage.getItem('inputData')))
                        }

                        // Call function to re-assign the objects based on dropdown option
                        function filterAndAssignObj(data, options) {
                            data?.forEach(table => {
                                if (table?.Tablename != "Table 1") {
                                    table?.TemplateData?.forEach(obj => {
                                        let mappingItem = {
                                            CoverageSpecification: obj.CoverageSpecification
                                        }

                                        options?.forEach(key => {
                                            if (obj[key?.includes("$") ? "'" + key : key] != undefined) {
                                                mappingItem[key?.includes("$") ? "'" + key : key] = obj[key?.includes("$") ? "'" + key : key] === "Details not available in the document" ? "" : obj[key?.includes("$") ? "'" + key : key];
                                            }
                                        })

                                        Object.keys(obj)?.forEach(key => {
                                            if (key !== 'CoverageSpecification' && key !== "POLICY LOB" && key !== "PolicyLob" && !options?.includes(key?.startsWith("'") ? key.substring(1) : key)) {
                                                delete obj[key];
                                            }
                                        })

                                        Object.assign(obj, mappingItem)
                                    })
                                }
                            })

                            return data;
                        };

                          let updatedAry = [];
                        if (selectedFilesFromDropdown && selectedFilesFromDropdown?.length > 0) {
                            updatedAry = filterAndAssignObj(table5Appened, selectedFilesFromDropdown)
                        }

                        // const reordered = updatedAry.map(table => {
                        //     const emptyItems = table.TemplateData.filter(item =>
                        //         Object.entries(item).some(
                        //             ([k, v]) => k !== "CoverageSpecification" && (!v || (typeof v === 'string' && !v.trim()))
                        //         )
                        //     );

                        //     const nonEmptyItems = table.TemplateData.filter(item =>
                        //         !Object.entries(item).some(
                        //             ([k, v]) => k !== "CoverageSpecification" && (!v || (typeof v === 'string' && !v.trim()))
                        //         )
                        //     );

                        //     return { ...table, TemplateData: [...nonEmptyItems, ...emptyItems] };
                        // });

                        // Find Table 5 to push the filtered entries into it
                        const tableName = updatedAry?.length >= 5
                        ? updatedAry[updatedAry.length - 1]?.Tablename
                        : "Table 5";

                        const table5 = updatedAry?.find(t => t.Tablename ===  tableName);
                        if (table5 != undefined) {
                            // Iterate over all tables except Table 5
                            for (const table of updatedAry) {
                                if (table?.Tablename === tableName) continue;

                                const filteredData = [];

                                for (const item of table?.TemplateData) {
                                    // Get keys excluding CoverageSpecification
                                    const otherKeys = Object.keys(item).filter(k => k !== "CoverageSpecification");

                                    // Check if ALL of those keys have value ""
                                    const allEmpty = otherKeys.every(k => item[k] === "");

                                    if (allEmpty) {
                                        table5.TemplateData.push(item);
                                    } else {
                                        filteredData.push(item);
                                    }
                                }

                                table.TemplateData = filteredData;
                                const seen = new Set();

                                table5.TemplateData = table5.TemplateData.filter(item => {
                                    const key = JSON.stringify(item);
                                    if (seen.has(key)) return false;
                                    seen.add(key);
                                    return true;
                                });
                            }
                        }

                        const existingSpecs = new Set(
                            updatedAry
                                ?.filter(t => ["Table 2", "Table 3", "Table 4"]?.includes(t.Tablename))
                                ?.flatMap(t => t?.TemplateData?.map(d => d.CoverageSpecification))
                        );

                        // Step 2: Update Table 5 TemplateData by filtering out duplicates
                        updatedAry = updatedAry?.map(table => {
                            if (table.Tablename === tableName) {
                                return {
                                    ...table,
                                    TemplateData: table.TemplateData.filter(
                                        d => !existingSpecs.has(d.CoverageSpecification)
                                    )
                                };
                            }
                            return table;
                        });

                        generateProposalDataConfig.demo.config.borderInfo = generateProposalDataConfig.demo.config.borderInfo.filter(b => b.borderType !== "border-all");
                        updatedAry?.map((e, index) => {
                            if (e?.Tablename != 'Table 1' && e?.TemplateData?.length >= 1 && selectedFilesFromDropdown?.length > 0) {
                                let filteredData = generateProposalDataConfig.demo.celldata.filter((f, index) => f != null || !f);
                                renderProposalData2([...filteredData], e?.Tablename, updatedAry);
                            }
                        });

                        const celldata = generateProposalDataConfig.demo.celldata;
                        const totalRows = 500;
                        const totalCols = 50;

                        const dataMatrix = Array.from({ length: totalRows }, () =>
                            Array(totalCols)?.fill(null)
                        );

                        celldata?.forEach(cell => {
                            if (cell.r < totalRows && cell.c < totalCols) {
                                let v = { ...cell.v };
                                if (cell.rs && cell.cs) {
                                    v.mc = {
                                        r: cell.r,
                                        rs: cell.rs,
                                        c: cell.c,
                                        cs: cell.cs
                                    }
                                    dataMatrix[cell.r][cell.c] = v;

                                    for (let i = 0; i < cell.rs; i++) {
                                        for (let j = 0; j < cell.cs; j++) {
                                            // Skip the top-left corner (already assigned)
                                            if (i === 0 && j === 0) continue;

                                            const mergeRefR = cell.r + i;
                                            const mergeRefC = cell.c + j;

                                            // Only fill if within bounds
                                            if (mergeRefR < totalRows && mergeRefC < totalCols) {
                                                dataMatrix[mergeRefR][mergeRefC] = {
                                                    r: cell.r,
                                                    c: cell.c
                                                };
                                            }
                                        }
                                    }
                                } else {
                                    dataMatrix[cell.r][cell.c] = v;
                                }
                            }
                        });

                        generateProposalDataConfig.demo.data = dataMatrix;

                        const sheetName = "Proposal";
                        let sheets = luckysheet?.getluckysheetfile?.() || [];
                        let sheetList = Array.isArray(sheets) ? sheets : [];

                        let proposalSheet = sheetList?.find((s) => s.name === sheetName);

                        if (!proposalSheet && selectedFilesFromDropdown?.length > 0) {
                            luckysheet.setSheetAdd({
                                "name": sheetName,
                                "color": "",
                                "index": 1,
                                "status": 0,
                                "order": 1,
                                "celldata": [],
                                "config": {}
                            });

                            luckysheet.jfrefreshgrid()

                            sheets = luckysheet?.getluckysheetfile?.() || [];
                            sheetList = Array.isArray(sheets) ? sheets : [];

                            proposalSheet = sheetList.find((s) => s.name === sheetName);
                        }

                        if (selectedFilesFromDropdown?.length > 0) {
                            if (proposalSheet) {
                                proposalSheet.celldata = celldata;
                                proposalSheet.config = generateProposalDataConfig.demo.config;
                                proposalSheet.config.merge = generateProposalDataConfig.demo.config.merge;
                                proposalSheet.data = dataMatrix;
                                proposalSheet.row = totalRows;
                                proposalSheet.column = totalCols;

                                if (proposalSheet?.data != undefined) {
                                    delete proposalSheet?.data["0"];
                                    proposalSheet.data["0"] = discliamerIndex;
                                }

                                const proposalIndex = sheets?.findIndex(s => s.name === "Proposal");
                                if (proposalIndex !== -1) {
                                    luckysheet.setSheetActive(proposalIndex);
                                }

                                luckysheet.setluckysheet_select_save([{ row: [0, 0], column: [0, 0] }]);
                                luckysheet.scroll({
                                    targetRow: 0,
                                    targetColumn: 0
                                });
                            } else {
                                luckysheet.setSheetAdd({
                                    name: sheetName,
                                    celldata: celldata,
                                    config: generateProposalDataConfig.demo.config,
                                    data: dataMatrix,
                                    row: totalRows,
                                    column: totalCols,
                                    color: "",
                                });
                                luckysheet.jfrefreshgrid()
                            }
                        }

                        setTimeout(() => {
                            const updatedSheets = luckysheet.getluckysheetfile?.() || [];
                            const proposalSheet = updatedSheets?.find(s => s.name === "Sheet2");

                            if (proposalSheet) {
                                proposalSheet.name = generateProposalDataConfig.demo.name;
                                proposalSheet.celldata = generateProposalDataConfig.demo.celldata;
                                proposalSheet.config = generateProposalDataConfig.demo.config;
                                proposalSheet.data = dataMatrix;
                                proposalSheet.row = totalRows;
                                proposalSheet.column = totalCols;
                                proposalSheet.ch_width = generateProposalDataConfig.demo.ch_width;
                                proposalSheet.rh_height = generateProposalDataConfig.demo.rh_height;

                                if (typeof luckysheet?.refresh === "function") {
                                    luckysheet.jfrefreshgrid();
                                }

                                const removeEmptySheets = () => {
                                    const allSheets = luckysheet.getluckysheetfile?.() || [];
                                    allSheets.forEach(sheet => {
                                        if (sheet.celldata?.length === 0) {
                                            luckysheet.setSheetDelete();
                                            luckysheet.jfrefreshgrid();
                                        }
                                    });
                                };

                                removeEmptySheets();
                                const proposalIndex = updatedSheets.findIndex(s => s.name === "Proposal");
                                if (proposalIndex !== -1) {
                                    luckysheet.setSheetActive(proposalIndex);
                                }

                                luckysheet.setluckysheet_select_save([{ row: [0, 0], column: [0, 0] }]);
                                luckysheet.scroll({
                                    targetRow: 0,
                                    targetColumn: 0
                                });
                                luckysheet.setSheetName("Proposal")
                                isProposalActive()
                            } else {
                                console.warn("Proposal sheet not found after adding.");
                            }
                        }, 100);

                        if (selectedFilesFromDropdown.length === 0 && luckysheet.getConfig) {
                            const config = generateProposalDataConfig.demo.config;

                            if (config?.borderInfo && Array.isArray(config?.borderInfo)) {
                                const newBorderInfo = config?.borderInfo?.filter(b => b.borderType !== "border-all");

                                generateProposalDataConfig.demo.config.borderInfo = newBorderInfo;
                            }

                            if (proposalSheet) {
                                proposalSheet.celldata = [];
                                proposalSheet.config = {};
                                proposalSheet.data = [];
                                luckysheet.jfrefreshgrid();
                            }
                        }
                    }
                };

                const renderProposalData2 = (combinedata1, tableName, inputData) => {
                    const basedata = [...combinedata1];
                    const tableDatas = inputData?.find((data) => data.Tablename === tableName);
                    const ProposaltableColumnNamesOfValid = {};

                    const tablejson = tableDatas.TemplateData;
                    const value = Object?.values(tablejson);

                    let policyLOBValues = value?.map(item => item["POLICY LOB"] || item["PolicyLob"]);
                    if(policyLOBValues[0] == null) {
                        policyLOBValues = JSON.parse(sessionStorage.getItem('lob'));
                    } 

                    const policyLOBValuesForLobSplit = tablejson?.filter(item =>
                        avaliablelobs.includes(item["POLICY LOB"] || item["PolicyLob"])
                    );

                    const isLastTable = tableName === inputData[inputData.length - 1]?.Tablename;

                    if ( !isLastTable && policyLOBValuesForLobSplit && policyLOBValuesForLobSplit?.length > 0) {
                        tableName = 'Table 3';
                    }

                    let finalPolicyLOB = Array.isArray(policyLOBValues) ? policyLOBValues[0] : policyLOBValues;

                    const tablejsoncopy = tablejson?.map(item => {
                        const {
                            PolicyLob,
                            ["POLICY LOB"]: policyLob,
                            ...filteredItem
                        } = item;

                        return filteredItem;
                    });

                    let headers = Object.keys(tablejsoncopy[0]);

                    let headerRows1 = [];
                    let rowIndexForLOBStart = 0;

                    if (tableName === "Table 3" || (tableName === "Table 4" || tableDatas?.TemplateData[0]?.CoverageSpecification === "New/Deleted Forms (Forms on Current Policy But Not on Expiring Policy/Source Document)") || (tableName === "Table 5" || inputData[inputData.length -1]?.Tablename === tableName)){
                        rowIndexForLOBStart = basedata[basedata?.length - 1]?.r + 3;
                        headerRows1 = [
                            {
                                r: basedata[basedata?.length - 1]?.r + 3,
                                rs: 1,
                                c: 1,
                                cs: headers.length,
                                v: {
                                    ct: { fa: "General", t: "g" },
                                    m: tableName === "Table 3" ? finalPolicyLOB : (tableName === "Table 4" || tableDatas?.TemplateData[0]?.CoverageSpecification === "New/Deleted Forms (Forms on Current Policy But Not on Expiring Policy/Source Document)") ? "Forms Listed" : (tableName === "Table 5" || inputData[inputData.length - 1]?.Tablename === tableName) ? "Details not available" : "",
                                    v: tableName === "Table 3" ? finalPolicyLOB : (tableName === "Table 4" || tableDatas?.TemplateData[0]?.CoverageSpecification === "New/Deleted Forms (Forms on Current Policy But Not on Expiring Policy/Source Document)") ? "Forms Listed" : (tableName === "Table 5" || inputData[inputData.length - 1]?.Tablename === tableName) ? "Details not available" : "",
                                    fs: 11,
                                    ff: "\"Tahoma\"",
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    w: 55,
                                }
                            }
                        ]
                    };

                    const removalCode = headers.map(item => {
                        if (item === "CoverageSpecification") {
                            return tableName === "Table 2"
                                ? "Common Declarations"
                                : "Coverage Specifications";
                        }

                        return item;
                    });

                    headerRows1 = [
                        ...headerRows1,
                        ...removalCode?.map((item, index) => {
                            generateProposalDataConfig.demo.config.merge[`${tableName === "Table 2" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 4}_${1 + index}`] = {
                                "r": tableName === "Table 2" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 4,
                                "c": 1 + index,
                                "rs": 1,
                                "cs": 1
                            }

                            return {
                                r: tableName === "Table 2" ? basedata[basedata?.length - 1]?.r + 3 : basedata[basedata?.length - 1]?.r + 4,
                                rs: 1,
                                c: 1 + index,
                                cs: 1,
                                v: {
                                    ct: { fa: "General", t: "g" },
                                    ff: "\"Tahoma\"",
                                    m: item,
                                    v: item,
                                    merge: null,
                                    bg: "rgb(139,173,212)",
                                    bl: 0.5,
                                    tb: '2',
                                    w: 55,
                                    fs: `${header}`
                                }
                            }
                        })
                    ];

                    if (headerRows1?.length > 0) {
                        headerRows1.forEach((f, index) => {
                            if(tableName === "Table 3" && index !== 0) {
                                ProposaltableColumnNamesOfValid[f?.v?.v] = f?.c;
                            } else if (tableName !== "Table 3" && index !== 0) {
                                ProposaltableColumnNamesOfValid[f?.v?.v] = f?.c;
                            }
                        });
                    }

                    if (tableName === "Table 3" || (tableName === "Table 4" || tableDatas?.TemplateData[0]?.CoverageSpecification === "New/Deleted Forms (Forms on Current Policy But Not on Expiring Policy/Source Document)") || (tableName === "Table 5" || inputData[inputData.length -1].Tablename === tableName))  {
                        generateProposalDataConfig.demo.config.merge[`${rowIndexForLOBStart}_${1}`] = {
                            "r": rowIndexForLOBStart,
                            "c": 1,
                            "rs": 1,
                            "cs": headerRows1?.length - 1,
                        }
                    }

                    headerRows1 = [...headerRows1];

                    let headerRows1Values = [];

                    let rowIndex = headerRows1[headerRows1.length - 1]?.r + 1;
                    headers = [...headers];

                    tablejson?.map((item, cIndex) => {
                        let rowHeight = 30;
                        headers?.map((key, rIndex) => {
                            rowIndex = headerRows1Values?.length == 0 ? rowIndex : headerRows1Values?.length > 0 && rIndex == 0 ? headerRows1Values[headerRows1Values.length - 1]?.r + 1 : headerRows1Values[headerRows1Values.length - 1]?.r;
                            let text = item[key]?.toString()?.split('~~');
                            let ss = [];
                            if (text[0]?.trim()) {
                                ss.push({
                                    "ff": "\"Tahoma\"",
                                    "fc": "#000000",
                                    "fs": `${value}`,
                                    "cl": 0,
                                    "un": 0,
                                    "bl": 0,
                                    "it": 0,
                                    "v": text[0]
                                });
                            }

                            headerRows1Values.push({
                                r: rowIndex,
                                c: rIndex + 1,
                                v: {
                                    ct: { fa: "General", t: "inlineStr", s: ss },
                                    merge: null,
                                    w: 55,
                                    tb: '2',
                                }
                            });

                            if (text && rowHeight < parseInt(item[key]?.length / 3 + 20)) {
                                rowHeight = parseInt(item[key]?.length / 3 + 20);
                                generateProposalDataConfig.demo.config.rowlen[`${rowIndex}`] = rowHeight;
                            }

                            if (headerRows1[headerRows1.length - 1]?.r === (tableName === "Table 2" ? headerRows1[0]?.r : headerRows1[0]?.r + 1)) {
                                generateProposalDataConfig.demo.config.rowlen[`${headerRows1[headerRows1.length - 1]?.r}`] = 40;
                            }
                        })
                    });

                    headerRows1 = [...headerRows1, ...headerRows1Values];

                    const allRows2 = [...headerRows1];
                    allRows2.sort((a, b) => a.r - b.r);

                    if (allRows2 && allRows2?.length > 0) {
                        const proptableColumnDetailss = proposaltableColumnDetails;
                        proptableColumnDetailss["P" + tableDatas?.Tablename] = { "columnNames": ProposaltableColumnNamesOfValid, "range": { "start": allRows2[0]?.r, "end": allRows2[allRows2?.length - 1]?.r } }
                        setProposalTableColumnDetails(proptableColumnDetailss);
                    }

                    basedata.push(...allRows2);

                    if (!Array.isArray(generateProposalDataConfig.demo.config.borderInfo)) {
                        generateProposalDataConfig.demo.config.borderInfo = [];
                    }

                    generateProposalDataConfig.demo.config.borderInfo =
                        generateProposalDataConfig.demo.config.borderInfo.filter(bi => {
                            if (bi.rangeType !== "range") return true;
                            if (!bi.range || !bi.range[0]?.row) return true;
                            const r = bi.range?.[0]?.row;
                            return !(r && r[0] === headerRows1[0]?.r);
                        });

                    if (headerRows1?.length > 0 && headerRows1Values?.length > 0) {
                        generateProposalDataConfig.demo.config.borderInfo.push({
                            "rangeType": "range",
                            "borderType": "border-all",
                            "color": "#000",
                            "style": "1",
                            "range": [
                                {
                                    row: [
                                        headerRows1[0]?.r,
                                        headerRows1Values[headerRows1Values.length - 1]?.r
                                    ],
                                    column: [
                                        headerRows1[0]?.c,
                                        headerRows1[headerRows1.length - 1]?.c
                                    ]
                                }
                            ]
                        });
                    }

                    generateProposalDataConfig.demo.celldata = basedata;
                };
                window.renderProposalData1 = renderProposalData1;
                renderProposalData1();

                renderCsrQcLuckySheet();
            } catch (error) {
                console.error("Error fetching sheet data:", error);
            }
        };

        fetchDataAndRender();

        setTimeout(() => {
            dataCsrQcGrouping();
        }, 2000);

        const timer = setTimeout(() => {
            if (typeof luckysheet !== "undefined") {
                setShowFilter(true);
            }
        }, 4000);

        return () => {
            clearTimeout(timer);

            // Destroy Luckysheet instance if it exists
            if (luckysheetRef.current && typeof luckysheetRef.current.destroy === 'function') {
                luckysheetRef.current.destroy();
            }
        };
    }, [props?.sheetData]);


    const renderCsrQcLuckySheet = () => {
        if (luckysheet) {
            const options = {
                container: "luckysheet", // Container ID
                showinfobar: false,
                showsheetbar: true,
                lang: 'en',
                data: [apiDataConfig.demo],
                enableAddRow: false,
                showtoolbar: true,
                row: 2,
                column: 3,
                allowUpdate: true,
                enableAddBackTop: true,
                sheetRightClickConfig: {
                    delete: false,
                    copy: false,
                    rename: false,
                    color: false,
                    hide: false,
                    move: false,
                },
                showsheetbarConfig: {
                    add: false,
                    menu: false,
                },
                hook: {
                    workbookCreateAfter(json) {
                        luckysheet.setSheetZoom(1);
                    },
                    cellEditBefore(range) {
                        //code for variance options filters
                        if (range && range.length > 0 && range != undefined) {
                            let selectedRowIndex = range[0].row[0];

                            if (selectedRowIndex === 3) {
                                setTimeout(() => {
                                    luckysheet.exitEditMode();
                                }, 100);
                                return false;
                            }
                            // if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                            //     range[0]?.column[0] === range[0]?.column[1] && [3, 4, 5, 6].includes(range[0].row[0]) &&
                            //     range[0].column[0] === 4) {
                            // setTimeout(() => {
                            //     luckysheet.exitEditMode();
                            //     matchedOrUnMatchedFilter(range[0]?.row[0], "filter");
                            //     container?.current?.showSnackbar(range[0]?.row[0] === 4 ?
                            //         "Matched Records Filtered" : range[0]?.row[0] === 5 ? "Mismatch Records Filtered" :
                            //             range[0]?.row[0] === 6 ? "Details not available Questions filtered" : "Filter Removed", "info", true);
                            // }, 100);


                            // checkbox setvalue for Variances columns
                            // if (range && range.length > 0 && range != undefined) {
                            //     handleCellSelection(range);
                            // }
                            // return;
                            // }

                            if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === 3 && range[0].column[0] === 4) {
                                if (luckysheet.getSheet().name === 'Proposal') {
                                    setTimeout(() => {
                                        luckysheet.exitEditMode();
                                    }, 100);
                                }

                                return;
                            }

                            if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
                                range[0]?.column[0] === range[0]?.column[1] && range[0].column[0] === 0) {
                                setTimeout(() => {
                                    luckysheet.exitEditMode();
                                    dataCsrQcGrouping(range[0]?.row[0]);
                                }, 100);
                                return;
                            }
                        }

                        // code for trigger X-Ray
                        if (range[0].row[0] === range[0].row[1] && range[0].column[0] === range[0].column[1]) {
                            XRayRoute(range);
                        }

                        // Denied the action of selection of all the cells
                        if (range && range.length > 0 && range != undefined) {
                            if (luckysheet.getSheet().name !== 'Proposal') {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];

                                const tabledata = QctableColumnDetails;
                                const excludedColumns = ["columnid"];
                                const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                const tblSelectedRow = tabledata[selectedTable];
                                if (tblSelectedRow != undefined) {
                                    for (const key in tblSelectedRow.columnNames) {
                                        if (tblSelectedRow.columnNames[key] === 0) {
                                            delete tblSelectedRow.columnNames[key];
                                        }
                                    }

                                    let values = Object.keys(tblSelectedRow.columnNames);
                                    let docViewerIndex = values.indexOf("Document Viewer") + 1;

                                    if (selectedColumnIndex < docViewerIndex) {
                                        setTimeout(() => {
                                            luckysheet.exitEditMode();
                                        }, 100);
                                        return false;
                                    }
                                }
                            } else if (luckysheet.getSheet().name === 'Proposal') {
                                setTimeout(() => {
                                    luckysheet.exitEditMode();
                                }, 100);
                                return false;
                            }
                        }

                        // code to pop-Up the endorsement dialog
                        if (range && range.length > 0 && range != undefined) {
                            let selectedRowIndex = range[0].row[0];
                            let nullcolumncheck = luckysheet.getSheetData()[selectedRowIndex];
                            const isAllNull = nullcolumncheck.every(element => element === null);
                            if (!isAllNull) {
                                let selectedRowIndex = range[0].row[0];
                                let tabledata = QctableColumnDetails;
                                const excludedColumns = [""];
                                const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                let ranges = luckysheet.getRange();
                                let selectedcolumnindex = ranges[0].column[0];
                                let actionColumnTable = tabledata[selectedTable];
                                let values = actionColumnTable ? Object.values(actionColumnTable.columnNames) : [];
                                let largestIndex = Math.max(...values);
                                let Actioncolumnindex = largestIndex - 3;
                                let Requestcolumnindex = largestIndex - 2;
                                let Notescolumnindex = largestIndex - 1;
                                if (actionColumnTable !== undefined) {
                                    if (selectedRowIndex >= actionColumnTable.range.start + 2) {
                                        if ((Actioncolumnindex == selectedcolumnindex || Requestcolumnindex == selectedcolumnindex || Notescolumnindex == selectedcolumnindex)) {
                                            toggleAMSDialog()
                                            return false;
                                        }
                                    }
                                } else {
                                    return false;
                                }
                            }
                        }
                    },
                    cellUpdated: function (r, c, oldValue, newValue, isRefresh) {
                        let range = luckysheet.getRange();
                        if (luckysheet.getSheet().name !== 'Proposal') {
                            // -----------***Set max row length with cell update/clicked***-----------//
                            let getRowData = luckysheet.getcellvalue(r);
                            getRowData = getRowData?.filter((f) => f != null);
                            let length = [];
                            let maxLength = 0;
                            getRowData?.forEach((f) => {
                                if (f?.ct?.s) {
                                    if (f?.ct?.s?.length > 1) {
                                        var text = '';
                                        f?.ct?.s?.forEach((e) => { text += e?.v })
                                        length.push(text?.length);
                                    } else { length.push(f?.ct?.s[0]?.v?.length) }
                                }
                            });
                            length = Array.from(new Set(length));
                            length.forEach((f) => {
                                if (f > maxLength) {
                                    maxLength = f;
                                }
                            });

                            let config = luckysheet.getConfig();
                            if (r == 3) {
                                config.rowlen[r] = 19;
                            } else {
                                config.rowlen[r] = maxLength && maxLength > 5 ? maxLength / 2 + 20 : 30;
                            }
                            luckysheet.setConfig(config);
                        }
                        // ----------------------------------------------------------------------//
                        // -----------***Handled the scroll issue on edit for the cells***-----------//
                        // if (r != undefined && c != undefined) {
                        //     let targetColumnIndex = c;
                        //     let sheetCheck = luckysheet?.getSheet();
                        //     let zoomCheck = sheetCheck?.zoomRatio;
                        //     if (zoomCheck != 1) {
                        //         let rowDataa = luckysheet.getcellvalue(r);
                        //         let filteredRow = rowDataa[targetColumnIndex];
                        //         if (filteredRow && filteredRow != undefined && filteredRow?.ct?.s != undefined) {
                        //             let valueAtV = filteredRow?.v || filteredRow?.ct?.s[0]?.v;
                        //             let transformedData = {
                        //                 "ct": {
                        //                     "fa": "@",
                        //                     "t": "inlineStr",
                        //                     "s": [
                        //                         {
                        //                             "v": valueAtV,
                        //                             "ff": filteredRow?.ff,
                        //                             "fs": 7 || filteredRow?.ct?.s[0]?.fs
                        //                         }
                        //                     ]
                        //                 },
                        //                 "m": valueAtV,
                        //                 "v": valueAtV,
                        //                 "ff": `"${filteredRow?.ff}"`,
                        //                 "bg": `"${filteredRow?.bg}"`,
                        //                 "tb": filteredRow?.tb,
                        //                 "w": filteredRow?.w,
                        //                 "row": r,
                        //                 "column": c
                        //             };
                        //             luckysheet.scroll({
                        //                 targetRow: transformedData?.row - 2,
                        //                 targetColumn: 0
                        //             });
                        //         }
                        //     }
                        // }

                        // Always revert the cell value to oldValue except the endorsement columns
                        if (range && range.length > 0 && range != undefined) {
                            if (luckysheet.getSheet().name !== 'Proposal') {
                                let selectedColumnIndex = range[0].column[0];

                                const tabledata = QctableColumnDetails;
                                const excludedColumns = ["columnid"];
                                const selectedTable = findTableForIndex(r, tabledata, excludedColumns);
                                const tblSelectedRow = tabledata[selectedTable];
                                if (tblSelectedRow != undefined) {
                                    if (selectedTable != 'Table 1') {
                                        for (const key in tblSelectedRow.columnNames) {
                                            if (tblSelectedRow.columnNames[key] === 0) {
                                                delete tblSelectedRow.columnNames[key];
                                            }
                                        }
                                        let values = tblSelectedRow ? Object.keys(tblSelectedRow.columnNames) : [];
                                        let docViewerIndex = values.indexOf("NotesFreeFill") + 1;
                                        if (oldValue && oldValue.ct && oldValue.ct.s && oldValue.ct.s[0] && oldValue != undefined) {
                                            if (selectedColumnIndex < docViewerIndex) {
                                                setCellValue(r, c, oldValue);
                                            }
                                        }
                                        luckysheet.exitEditMode();
                                        return false;
                                    }

                                    if (r === 3 && c === 4) {
                                        // if (getRowData[c]?.ct?.s?.map(e => e?.m)?.includes('Generate Summary for Proposal')) {
                                        setCellValue(r, c, oldValue);
                                        // }
                                        luckysheet.exitEditMode();
                                        return false;
                                    }
                                }
                            } else if (luckysheet.getSheet().name === 'Proposal') {
                                setCellValue(r, c, oldValue);
                                luckysheet.exitEditMode();
                                return false;
                            }
                        }
                    },
                    rangePasteBefore: function (range, data) {
                        // Denied the action of Copy/Paste for all the cells 
                        if (range && range.length > 0 && range != undefined) {
                            if (luckysheet.getSheet().name !== 'Proposal') {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];

                                let tabledata = QctableColumnDetails;
                                const selectedTable = findTblRowAllIndex(selectedRowIndex, tabledata);
                                const tblSelectedRow = tabledata[selectedTable];
                                const filteredIndex = filterSelectedRowIndexForCopyPaste(tblSelectedRow, selectedRowIndex);
                                let values = tblSelectedRow ? Object.values(tblSelectedRow.columnNames) : [];
                                let largestIndex = Math.max(...values);
                                let Actioncolumnindex = largestIndex - 3;
                                let Requestcolumnindex = largestIndex - 2;
                                let Notescolumnindex = largestIndex - 1;

                                if (tblSelectedRow !== undefined) {
                                    if ((selectedRowIndex >= tblSelectedRow.range.start + 2)) {
                                        // if ((largestIndex != selectedColumnIndex && Requestcolumnindex != selectedColumnIndex && Notescolumnindex != selectedColumnIndex)) {
                                        if ((largestIndex != selectedColumnIndex)) {
                                            let isAction = false;
                                            range.forEach(item => {
                                                const targetRow = item.row[0];
                                                if (targetRow === filteredIndex) {
                                                    isAction = true;
                                                }
                                            });

                                            if (isAction == true) {
                                                return false;
                                            }
                                        }
                                    }

                                    const getRowData = luckysheet.getcellvalue(selectedRowIndex);
                                    if (selectedRowIndex === 3 && selectedColumnIndex === 4) {
                                        if (getRowData[selectedColumnIndex]?.ct?.s?.map(e => e?.m)?.includes('Generate Summary for Proposal')) {
                                            return false;
                                        }
                                    }
                                }
                            } else if (luckysheet.getSheet().name === 'Proposal') {
                                return false;
                            }
                        }
                    },
                    rangeSelect: function (index, sheet) {
                        //Handled the functionality for Del key operation and CTrl+ d shortcut options
                        let range = luckysheet?.getRange();

                        if (range && range.length > 0 && range != undefined) {
                            if (luckysheet.getSheet().name !== 'Proposal') {
                                let selectedRowIndex = range[0].row[0];
                                let selectedColumnIndex = range[0].column[0];

                                const tabledata = QctableColumnDetails;
                                if (tabledata != null) {
                                    const excludedColumns = "";
                                    const selectedTable = findTableForIndex(selectedRowIndex, tabledata, excludedColumns);
                                    const tblSelectedRow = tabledata[selectedTable];

                                    let values = tblSelectedRow ? Object.keys(tblSelectedRow.columnNames) : [];
                                    let docViewerIndex = values.indexOf("NotesFreeFill") + 1;

                                    if (index && sheet && sheet.length > 0) {
                                        document.onkeyup = function (e) {
                                            if (e.which != 40) {
                                                if ((e.which == 46 || e.which == 8)) {
                                                    if ((selectedTable != "Table 1")) {
                                                        if ((selectedColumnIndex < docViewerIndex)) {
                                                            luckysheet.undo()
                                                        }
                                                    } else if (selectedTable == "Table 1") {
                                                        const getRange = QctableColumnDetails
                                                        const rangeEnd = getRange["Table 1"].range.end
                                                        const range = luckysheet.getRange();
                                                        const sheetrange = range[0].row[1];
                                                        if ((rangeEnd >= sheetrange || rangeEnd <= sheetrange)) {
                                                            luckysheet.undo()
                                                        }
                                                    }

                                                    const getRowData = luckysheet.getcellvalue(selectedRowIndex);
                                                    if (selectedRowIndex === 3 && selectedColumnIndex === 4) {
                                                        if (getRowData[selectedColumnIndex]?.ct?.s?.map(e => e?.m)?.includes('Generate Summary for Proposal')) {
                                                            luckysheet.undo()
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else if (luckysheet.getSheet().name === 'Proposal') {
                                document.onkeyup = function (e) {
                                    if (e.which != 40) {
                                        if ((e.which == 46 || e.which == 8)) {
                                            luckysheet.undo()
                                        }
                                    }
                                }
                            }
                        }
                    },
                    cellAllRenderBefore: function (data, sheetFile, ctx) {
                        if (sheetFile && sheetFile != undefined) {
                            if (sheetFile?.name === JSON.parse(sessionStorage.getItem('lob'))) {
                                setSaveFlag(false)
                            } else if (sheetFile?.name !== JSON.parse(sessionStorage.getItem('lob'))) {
                                setSaveFlag(true)
                            }
                        }
                    }
                },
                cellRightClickConfig: {
                    copy: false, // copy
                    copyAs: false, // copy as
                    paste: false, // paste
                    insertRow: false, // insert row
                    insertColumn: false, // insert column
                    deleteRow: false, // delete the selected row
                    deleteColumn: false, // delete the selected column
                    deleteCell: false, // delete cell
                    hideRow: false, // hide the selected row and display the selected row
                    hideColumn: false, // hide the selected column and display the selected column
                    rowHeight: false, // row height
                    columnWidth: false, // column width
                    clear: false, // clear content
                    matrix: false, // matrix operation selection
                    sort: false, // sort selection
                    filter: false, // filter selection
                    chart: false, // chart generation
                    image: false, // insert picture
                    link: false, // insert link
                    data: false, // data verification
                    cellFormat: false // Set cell format
                },
                showtoolbarConfig: {
                    moreFormats: false,
                    sortAndFilter: false,
                    link: false,
                    chart: false,
                    print: false,
                    textRotateMode: false,
                    image: false,
                    postil: false,
                    dataVerification: false,
                    splitColumn: false,
                    screenshot: false,
                    findAndReplace: false,
                }
            };
            luckysheetRef.current = window.luckysheet.create(options);
        }
    }

    // Create dropdown on right-click for generate summary for proposal functionality
    $(document).ready(function () {
        if ($("#customDropdown").length === 0) {
            $('body').append(`
            <div id="customDropdown" 
                style="display:none; position:absolute; background:white; border:1px solid #ccc; padding:5px; 
                min-width:260px; box-shadow:2px 2px 5px rgba(0,0,0,0.2); border-radius:3px; 
                font-family:Arial,sans-serif; font-size:14px; z-index:9999;">
                <div id="dropdownItems"></div>
                <button id="applySelection" 
                    style="margin-top:3px; padding:5px 5px; font-size:10px; border-radius:5px; cursor:pointer;">Confirm</button>
            </div>
        `);
        }

        let cellSelected = false;

        $("#luckysheet").off("click").on("click", function (event) {
            const sheetName = luckysheet.getSheet().name;
            if (sheetName !== 'Proposal') {
                event.stopPropagation();

                const range = luckysheet.getRange();
                const rowRange = range[0].row[0];
                const columnRange = range[0].column[0];

                // Only trigger for 4th row & 4th column
                if (rowRange === 3 && columnRange === 4) {
                    if (cellSelected) {
                        cellSelected = false;
                        return;
                    }

                    let savedSelections = JSON.parse(sessionStorage.getItem('generateProposalSelectedFiled') || "[]");

                    const qcData = props.sheetData;  // or from context if you lifted state

                    if (qcData && qcData.CommonDeclaration) {
                        let seen = new Set();
                        let orderedFiles = [];

                        qcData.CommonDeclaration.forEach(item => {
                            if (!seen.has(item.DocumentName)) {
                                seen.add(item.DocumentName);
                                orderedFiles.push(item.DocumentName);
                            }
                        });

                        let listItems = orderedFiles.map(f => {
                            let checked = savedSelections.includes(f) ? "checked" : "";
                            return `<div>
            <input type="checkbox" class="dropdown-check" value="${f}" ${checked}/> ${f}
        </div>`;
                        }).join("");

                        $("#dropdownItems").html(listItems);
                    }

                    // Use luckysheet selection info for exact pixel position
                    // Get scroll info from Luckysheet container
                    const $scrollContainer = $(".luckysheet-cell-main"); // main scrollable container
                    const scrollLeft = $scrollContainer.scrollLeft();
                    const scrollTop = $scrollContainer.scrollTop();

                    // Always target row 4 (index 3) and column D (index 3)
                    const row = 3;
                    const col = 3;

                    // Get current selection info
                    const selectInfo = luckysheet.getluckysheet_select_save();
                    if (selectInfo && selectInfo.length > 0) {
                        const sel = selectInfo.find(s => s.row[0] <= row && s.row[1] >= row);
                        if (sel) {
                            const $sheetContainer = $("#luckysheet");
                            const containerOffset = $sheetContainer.offset();

                            const extraOffset = 80; // pixels below the cell
                            // const horizontalOffset = 30;

                            // Calculate left position of column D relative to container
                            const leftPos = containerOffset.left + sel.left - scrollLeft;//+ horizontalOffset

                            // Calculate top position of row 4 relative to container
                            const topPos = containerOffset.top + sel.top + sel.height + extraOffset - scrollTop;

                            $("#customDropdown").css({
                                top: topPos,
                                left: leftPos,
                                display: "block"
                            });
                        } else {
                            console.warn("Selection info not found for row 4, column 4");
                        }
                    }
                } else {
                    cellSelected = false;
                    $("#customDropdown").hide();
                }
            }
        });

        // Confirm button
        $(document).off("click", "#applySelection").on("click", "#applySelection", function (e) {
            e.stopPropagation();
            const selectedFiles = [];
            $(".dropdown-check:checked").each(function () {
                selectedFiles.push($(this).val());
            });

            sessionStorage.setItem('generateProposalSelectedFiled', JSON.stringify(selectedFiles));

            if (typeof window.renderProposalData1 === "function") {
                window.renderProposalData1(selectedFiles);
            }

            $("#customDropdown").hide();
            cellSelected = true;
        });

        // Hide if clicked outside
        $(document).on("click", function (event) {
            if (!$(event.target).closest("#customDropdown").length &&
                !$(event.target).closest("#luckysheet").length) {
                $("#customDropdown").hide();
            }
        });

        // Hide if scrolling sheet
        $(".luckysheet-cell-main").on("scroll", function () {
            $("#customDropdown").hide();
        });
    });



    const setCellValue = (row, column, data) => {
        if (luckysheet && (luckysheet != undefined || luckysheet != null)) {
            luckysheet?.setcellvalue(row, column, luckysheet?.flowdata(), data);
            luckysheet?.jfrefreshgrid();
        }
    }

    // Function to handle status cell selection checkbox color and update values
    let previousCell = { row: null, col: null, text: 'string' };
    const handleCellSelection = async (range) => {
        if (range && range[0]?.row && range[0]?.column && range[0]?.row[0] === range[0]?.row[1] &&
            range[0]?.column[0] === range[0]?.column[1] && [3, 4, 5, 6].includes(range[0]?.row[0]) &&
            range[0]?.column[0] === 4) {

            const currentRow = range[0]?.row[0];
            const currentCol = 4;

            let getRowValue = luckysheet.getcellvalue(currentRow);
            const objectAtIndex4 = getRowValue[4];
            if (objectAtIndex4?.ct?.s && Array.isArray(objectAtIndex4?.ct?.s)) {
                let varianceText = objectAtIndex4?.ct?.s[1]?.v
                if (varianceText === 'Matched' || varianceText === 'All Variances' || varianceText === 'Mismatch' || varianceText === 'Details not available') {
                    const revertBoxCode = {
                        "ct": {
                            "fa": "General",
                            "t": "inlineStr",
                            "s": [
                                {
                                    "fs": "16",
                                    "v": "■ "
                                },
                                {
                                    "vt": "0",
                                    "ht": "1",
                                    "fs": "9",
                                    "un": 0,
                                    "bl": 1,
                                    "fc": "#0000ff",
                                    "ff": "\"Tahoma\"",
                                    "m": varianceText,
                                    "v": varianceText
                                }
                            ]
                        },
                        "merge": null,
                        "w": 55,
                        "tb": "2",
                        "fc": "#0000ff",
                        "fs": "16"
                    }

                    // Update the current cell with revertBoxCode
                    setCellValue(currentRow, currentCol, revertBoxCode);

                    // Restore the previous cell with previouscode if there was a previous selection
                    if (previousCell.row !== null && previousCell.col !== null && previousCell.text !== undefined) {
                        const previousBoxcode = {
                            "ct": {
                                "fa": "General",
                                "t": "inlineStr",
                                "s": [
                                    {
                                        "fs": "16",
                                        "v": "□ "
                                    },
                                    {
                                        "vt": "0",
                                        "ht": "1",
                                        "fs": "9",
                                        "un": 0,
                                        "bl": 1,
                                        "fc": "#0000ff",
                                        "ff": "\"Tahoma\"",
                                        "m": previousCell.text,
                                        "v": previousCell.text
                                    }
                                ]
                            },
                            "merge": null,
                            "w": 55,
                            "tb": "2",
                            "fc": "#0000ff",
                            "fs": "16"
                        }
                        setCellValue(previousCell.row, previousCell.col, previousBoxcode);
                    }

                    // Update the previousCell to the current cell
                    previousCell.row = currentRow;
                    previousCell.col = currentCol;
                    previousCell.text = varianceText
                }
            }
        }
    }

    const XRayRoute = (range, flag) => {
        if (range) {
            const row = range[0].row[0];
            const column = range[0].column[0];
            let checklistData = JSON.parse(sessionStorage.getItem('inputData')) || [];;

            const tableDetails = QctableColumnDetails;
            let keys = Object.keys(tableDetails);
            if (keys && keys?.length > 0 && checklistData && checklistData.length > 0 && row > 0 && column > 0) {
                let tableName = '';
                keys.forEach((f) => {
                    const tableCData = tableDetails[f];
                    const tRangeData = tableCData?.range;
                    if (tableCData && tRangeData && tRangeData?.start <= row && tRangeData?.end >= row) {
                        tableName = f;
                    }
                });
                if (tableName && tableName != 'Table 1') {
                    const activeTableData = tableDetails[tableName];
                    const documentviewerIndex = activeTableData?.columnNames["Document Viewer"];
                    if (documentviewerIndex && documentviewerIndex === column) {
                        let activeTableDBData = {};
                        const filteredData = checklistData.filter((f) => f?.Tablename === tableName);
                        if (filteredData && filteredData?.length > 0) {
                            activeTableDBData = filteredData[0];
                            const activeTableRange = activeTableData?.range;
                            const configureStartFrom = (activeTableRange?.end - activeTableRange.start) - activeTableDBData?.TemplateData?.length;
                            const startT = activeTableRange?.start + configureStartFrom + 1;
                            const endT = activeTableRange?.end;
                            const indexSet = Array.from({ length: endT - startT + 1 }, (_, i) => startT + i);
                            // console.log(indexSet);
                            if (indexSet && indexSet?.length > 0) {
                                const recordIndexToGet = indexSet.indexOf(row);
                                // console.log("recordIndexToGet : ", recordIndexToGet);
                                if (recordIndexToGet >= 0) {
                                    const selectedRecordData = activeTableDBData?.TemplateData[recordIndexToGet];
                                    const XRrayURL = selectedRecordData["DocumentViewer"];
                                    if (XRrayURL) {
                                        window.open(XRrayURL, '_blank', 'noopener');
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }

    const matchedOrUnMatchedFilter = (rowIndex, type) => {
        if (rowIndex === 6 || rowIndex === 4 || rowIndex === 5) {
            let checklistData = JSON.parse(sessionStorage.getItem('inputData')) || [];

            const tableDetails = QctableColumnDetails;
            let keys = Object.keys(tableDetails)?.filter((f) => f !== "Table 1");
            let recordsToHide = [];
            keys.forEach((f) => {
                const tableConfigData = tableDetails[f];
                const recordRange = tableConfigData?.range;
                const sourceColumns = "Status";
                const findData = checklistData.find((fi) => fi?.Tablename == f);
                if (findData?.TemplateData && findData?.TemplateData?.length > 0) {
                    findData?.TemplateData.forEach((item, itemIndex) => {
                        if (rowIndex === 5) { //for unmatched(variance)
                            let needToHide = true;
                            const srCData = item[sourceColumns];
                            if (needToHide && srCData && srCData?.trim()?.toLowerCase() == "mismatch") {
                                needToHide = false;
                            }
                            if (needToHide) {
                                recordsToHide.push(recordRange?.start + itemIndex + 3);
                            }
                        } else if (rowIndex === 4) {
                            let needToHide = true;
                            const srCData = item[sourceColumns];
                            if (needToHide && srCData && srCData?.trim()?.toLowerCase() == "matched") {
                                needToHide = false;
                            }
                            if (needToHide) {
                                recordsToHide.push(recordRange?.start + itemIndex + 3);
                            }
                        } else if (rowIndex === 6) {
                            let needToHide = true;
                            const srCData = item[sourceColumns];
                            if (srCData && srCData?.trim()?.toLowerCase() == "details not available") {
                                needToHide = false;
                            }

                            if (needToHide) {
                                recordsToHide.push(recordRange?.start + itemIndex + 3);
                            }
                        }
                    });
                }
            });
            if (recordsToHide?.length > 0) {
                recordsToHide = groupNumbers(recordsToHide);
            }
            showOrHideRecords(recordsToHide);
            let topConfig = 0;
            if (type === "filter") {
                const sheetdatas = luckysheet.find("Common Declarations");
                luckysheet.scroll({
                    targetRow: sheetdatas[0].row,
                    targetColumn: 0
                });
            } else {
                $("#luckysheet-scrollbar-y").scrollTop(topConfig + 400);
            }
        } else {
            showOrHideRecords([]);
            let topConfig = 0;
            if (type === "filter") {
                const sheetdatas = luckysheet.find("Common Declarations");
                luckysheet.scroll({
                    targetRow: sheetdatas[0].row,
                    targetColumn: 0
                });
            } else {
                $("#luckysheet-scrollbar-y").scrollTop(topConfig + 400);
            }
            dataCsrQcGrouping(0);
        }
    }

    function iconvaluestorage(newValue) {
        let existingValues = JSON.parse(sessionStorage.getItem('IconShownIndex')) || [];
        existingValues.push(newValue);
        sessionStorage.setItem('IconShownIndex', JSON.stringify(existingValues));
    };

    const dataCsrQcGrouping = (ToBeShownIndex) => {
        sessionStorage.setItem('selectedgrouping', ToBeShownIndex);
        if (ToBeShownIndex != undefined) {
            iconvaluestorage(ToBeShownIndex);
        }
        let colRecordTect = '';
        if (ToBeShownIndex > 0) {
            const rowRecord = luckysheet.getcellvalue(ToBeShownIndex);
            const columnRecord = rowRecord[0];
            colRecordTect = getText(columnRecord, false);
            if (colRecordTect != "-" && colRecordTect != "+") {
                return;
            }
        }

        let checklistData = JSON.parse(sessionStorage.getItem('inputData')) || [];

        const tableDetails = QctableColumnDetails;
        let keys = Object.keys(tableDetails)?.filter((f) => f !== "Table 1");
        let recordsToHide = [];
        keys?.forEach((f) => {
            const tableConfigData = tableDetails[f];
            const recordRange = tableConfigData?.range;
            const shortQuestion = [];
            const findData = checklistData?.find((fi) => fi?.Tablename == f);
            if (findData && findData?.TemplateData?.length > 0) {
                const backUpTemplateData = findData?.TemplateData;
                avaliablelobs?.forEach((lob) => {
                    backUpTemplateData?.forEach((item) => {
                        if (item["PolicyLob"] && item["PolicyLob"]?.toUpperCase()?.includes(lob.toUpperCase())) {
                            f = "Table 3";
                        }
                    });
                });
                let needIgnorance = false;
                const ignoranceShortCode = [];
                if (ToBeShownIndex > 0 && recordRange?.start < ToBeShownIndex && recordRange?.end >= ToBeShownIndex) {
                    needIgnorance = true;
                }
                const ignoreQCSet = [];
                findData?.TemplateData?.forEach((item, itemIndex) => {
                    let questionText = item["ChecklistQuestion"];
                    if (questionText) {
                        questionText = questionText?.toUpperCase()?.trim();
                        const questionCode = questionText?.substring(0, 3);

                        let isIgnorancecheck = false;
                        if (needIgnorance) {
                            isIgnorancecheck = ((recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2)) === ToBeShownIndex) && colRecordTect == "+";
                            if (isIgnorancecheck) {

                                ignoranceShortCode.push(questionCode);
                            }
                        } else if (ToBeShownIndex && ToBeShownIndex > 0) {
                            // ignoreQCSet, isIgnorancecheck
                            if (questionCode && !ignoreQCSet?.includes(questionCode)) {
                                let colRecordText1 = '';
                                const rowRecord1 = luckysheet.getcellvalue(recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2));
                                const columnRecord1 = rowRecord1[0];
                                colRecordText1 = getText(columnRecord1, false);
                                if (colRecordText1 == "-") {
                                    ignoreQCSet.push(questionCode);
                                }
                            }
                        }
                        if (shortQuestion?.includes(questionCode)) {
                            if ((!ignoranceShortCode || (ignoranceShortCode && ignoranceShortCode?.length === 0)) && (ignoreQCSet?.length === 0)) {
                                recordsToHide.push(recordRange?.start + itemIndex + (f == "Table 3" ? 4 : 3));
                            }
                            else if (!ignoranceShortCode?.includes(questionCode) && !ignoreQCSet?.includes(questionCode)) {
                                recordsToHide.push(recordRange?.start + itemIndex + (f == "Table 3" ? 4 : 3));
                            }
                        } else {
                            const hasMoreThanOne = backUpTemplateData.filter((qcF) => {
                                const cqTextForFilter = qcF["ChecklistQuestion"];
                                if (cqTextForFilter) {
                                    const cqFormatFixText = cqTextForFilter?.toUpperCase()?.trim();
                                    if (cqFormatFixText?.substring(0, 3) == questionCode) {
                                        return qcF;
                                    }
                                }
                            });
                            if (hasMoreThanOne && hasMoreThanOne?.length > 1) {
                                const dataToPopulate = {
                                    "m": ignoreQCSet?.includes(questionCode) ? "-" : ToBeShownIndex && ToBeShownIndex > 0 && isIgnorancecheck ? colRecordTect == "-" ? "+" : "-" : "+",
                                    "ct": {
                                        "fa": "General",
                                        "t": "g"
                                    },
                                    "v": ignoreQCSet?.includes(questionCode) ? "-" : ToBeShownIndex && ToBeShownIndex > 0 && isIgnorancecheck ? colRecordTect == "-" ? "+" : "-" : "+",
                                    "ht": "0",
                                    "fs": `${header}`,
                                    "fc": "#000000",
                                    "bl": 1
                                };

                                setCellValue(recordRange?.start + itemIndex + (f == "Table 3" ? 3 : 2), 0, dataToPopulate)

                                let storedvalues = JSON.parse(sessionStorage.getItem('IconShownIndex'));
                                if (storedvalues != null) {
                                    const frequencyMap = {};
                                    storedvalues?.forEach(value => {
                                        frequencyMap[value] = (frequencyMap[value] || 0) + 1;
                                    });

                                    const finalset = storedvalues?.filter(value => frequencyMap[value] === 1);

                                    const dataPopulate = {
                                        "m": "-",
                                        "ct": {
                                            "fa": "General",
                                            "t": "g"
                                        },
                                        "v": "-",
                                        "ht": "0",
                                        "fs": `${header}`,
                                        "fc": "#000000",
                                        "bl": 1
                                    };
                                    sessionStorage.setItem('IconShownIndex', JSON.stringify(finalset));
                                    finalset?.forEach(value => {
                                        setCellValue(value, 0, dataPopulate);
                                    });

                                }
                            }
                            shortQuestion.push(questionCode);
                        }
                    }
                })
            }
        });
        if (recordsToHide?.length > 0) {
            recordsToHide = groupNumbers(recordsToHide);
        }
        showOrHideRecords(recordsToHide, ToBeShownIndex);
    }

    const showOrHideRecords = (rowSet, setid) => {
        var groupingData = sessionStorage.getItem('selectedgrouping');

        if (groupingData !== "undefined") {
            let beforeselectedvalue = +groupingData + 2;
            updateLocalStorage(beforeselectedvalue);
            let storedValues = JSON.parse(sessionStorage.getItem('hitedselectedValues')) || [];
            const removedArrays = [];
            rowSet = rowSet?.filter(innerArray => {
                const containsK = innerArray?.includes(beforeselectedvalue);
                const containsStoredValue = innerArray?.some(value => storedValues?.includes(value));
                if (containsK || containsStoredValue) {
                    removedArrays.push(innerArray);
                    return false;
                }
                return true;
            });

            let existingRemovedArrays = JSON.parse(sessionStorage.getItem('removedArrays')) || [];
            existingRemovedArrays.push(...removedArrays);
            sessionStorage.setItem('removedArrays', JSON.stringify(existingRemovedArrays));
            sessionStorage.removeItem('selectedgrouping');

            if (storedValues?.includes(beforeselectedvalue)) {
                const getremovearray = JSON.parse(sessionStorage.getItem('removedArrays'));
                const arrayToAddBack = getremovearray?.find(innerArray => innerArray?.includes(beforeselectedvalue));

                if (arrayToAddBack) {
                    rowSet.push(arrayToAddBack);
                    const indexInRemovedArrays = existingRemovedArrays?.findIndex(removedArray =>
                        JSON.stringify(removedArray) === JSON.stringify(arrayToAddBack)
                    );

                    if (indexInRemovedArrays !== -1) {
                        existingRemovedArrays.splice(indexInRemovedArrays, 1);
                        let iconIndexset = JSON.parse(sessionStorage.getItem('IconShownIndex'));
                        if (iconIndexset.includes(beforeselectedvalue - 2)) {
                            const shouldRemove = (arr) => {
                                return getremovearray.some(removed =>
                                    arr.length === removed.length && arr.every(value => removed.includes(value)) &&
                                    removed.includes(beforeselectedvalue)
                                );
                            };
                            const filteredRowSet = rowSet.filter(arr => !shouldRemove(arr));
                            rowSet.length = 0;
                            Array.prototype.push.apply(rowSet, filteredRowSet);
                            existingRemovedArrays.splice(indexInRemovedArrays, 1);
                        }

                        sessionStorage.setItem('removedArrays', JSON.stringify(existingRemovedArrays));
                    }
                    var hiteval = JSON.parse(sessionStorage.getItem('hitedselectedValues'))
                    const hittedvalues = hiteval.filter(value => value !== beforeselectedvalue);

                    sessionStorage.setItem('hitedselectedValues', JSON.stringify(hittedvalues));
                }
            }
        }

        const config = luckysheet.getConfig();
        const hiddenRows = config?.rowhidden ? Object.keys(config?.rowhidden) : [];
        if (hiddenRows && hiddenRows?.length > 0) {
            const parsedSet = hiddenRows.map((f) => parseInt(f));
            const grouppedSet = groupNumbers(parsedSet);
            grouppedSet.forEach((f) => {
                luckysheet.showRow(f[0], f[f?.length - 1]);
            });
            luckysheet.scroll({
                targetRow: setid,
                targetColumn: 0
            });
        }
        if (rowSet?.length > 0) {
            rowSet.forEach((f) => {
                if (f?.length > 0) {
                    luckysheet.hideRow((f[0] - 1), (f[f?.length - 1] - 1));
                } else {
                    luckysheet.hideRow((f[0] - 1), (f[f?.length - 1] - 1));
                }
            });
            luckysheet.scroll({
                targetRow: setid,
                targetColumn: 0
            });
        }
    }

    function updateLocalStorage(beforeValue) {
        let basedatas = JSON.parse(sessionStorage.getItem('hitedselectedValues')) || [];
        if (basedatas.length === 0 || !basedatas.includes(beforeValue)) {
            basedatas.push(beforeValue);
        }
        sessionStorage.setItem('hitedselectedValues', JSON.stringify(basedatas));
    }

    const groupNumbers = (data) => {
        data = data.sort((a, b) => a - b)
        const groupedData = [];

        if (data.length === 0) {
            return;
        }

        let currentGroup = [data[0]];

        for (let i = 1; i < data.length; i++) {
            if (data[i] === data[i - 1] || data[i] === data[i - 1] + 1) {
                currentGroup.push(data[i]);
            } else {
                groupedData.push(currentGroup);
                currentGroup = [data[i]];
            }
        }
        groupedData.push(currentGroup);
        return groupedData;
    };

    const handleIconClick = () => {
        toggleFilterDialog();
    }

    const toggleFilterDialog = () => {
        setOpenFilterDialog(!openFilterDialog);
    };

    const handleFilterDialogClose = (e) => {
        setOpenFilterDialog(false);
        if (e?.filterData?.selectedOption1 && e?.filterData?.selectedOption2) {
            setFilterSelectionData(e?.filterData);
        } else {
            setFilterSelectionData(null);
            dataCsrQcGrouping(0);
        }
    };

    const toggleAMSDialog = () => {
        setDropDialog(!dropDialog);
        const propsData = luckysheet.getSheetData();
        setsheetState(propsData);
    };

    const funForDiscrepancyCol = (e) => {
        let range = luckysheet.getRange();
        let selectedIndex = range[0].row[0];
        let tabledata = QctableColumnDetails;
        const excludedColumns = [""];
        const selectedTable = findTableForIndex(selectedIndex, tabledata, excludedColumns);

        let actionColumnTable = tabledata[selectedTable]
        let values = Object.values(actionColumnTable.columnNames);
        let largestIndex = Math.max(...values);
        let Actioncolumnindex = largestIndex - 3
        let Requestcolumnindex = largestIndex - 2;
        let Notescolumnindex = largestIndex - 1
        let r = range[0].row[0];
        let c = range[0].column[0];

        if (e?.hasData) {
            if (e.selectedOption1 != null && e.selectedOption2 != null && e.selectedOption3 != null) {
                if (c == Actioncolumnindex) {
                    setCellValue(r, c, e.selectedOption1.text);
                    setCellValue(r, c + 1, e.selectedOption2.text);
                    setCellValue(r, c + 2, e.selectedOption3.text);
                } else if (c == Requestcolumnindex) {
                    setCellValue(r, c - 1, e.selectedOption1.text);
                    setCellValue(r, c, e.selectedOption2.text);
                    setCellValue(r, c + 1, e.selectedOption3.text);
                } else if (c == Notescolumnindex) {
                    setCellValue(r, c - 2, e.selectedOption1.text);
                    setCellValue(r, c - 1, e.selectedOption2.text);
                    setCellValue(r, c, e.selectedOption3.text);
                }
            } else {
                // Handle each option separately if not all are selected
                if (e && e.selectedOption1 && e.selectedOption1 != null) {
                    let actionText = e.selectedOption1.text;
                    setCellValue(r, Actioncolumnindex, actionText);
                    luckysheet.exitEditMode();
                }
                if (e && e.selectedOption2 && e.selectedOption2 != null) {
                    let requestText = e.selectedOption2.text;
                    setCellValue(r, Requestcolumnindex, requestText);
                    luckysheet.exitEditMode();
                }
                if (e && e.selectedOption3 && e.selectedOption3 != null) {
                    let notesText = e.selectedOption3.text;
                    setCellValue(r, Notescolumnindex, notesText);
                    luckysheet.exitEditMode();
                }
            }
        }
        setDropDialog(false);
    };
    if (luckysheet != undefined) {
        luckysheet.exitEditMode();
    }

    const handleYesQcDailog = () => {
        setYesQcDialog(false);
    }

    function extractCharacterValues(sheetValues) {
        const sheetValue = [];
        for (const row of sheetValues) {
            const rowIndex = row.rowIndex;
            const rowValue = row.rowValues;
            const nullFilterRowValues = rowValue.filter(f => f != null);
            for (const cell of nullFilterRowValues) {
                if (cell && cell.ct && cell.ct.s && cell.ct.s.length > 0 && cell.ct.s[0].hasOwnProperty('v')) {
                    if (cell?.ct?.s && cell?.ct?.s.length >= 2 && Array.isArray(cell?.ct?.s)) {
                        let concatenatedValues = cell?.ct?.s?.map(item => item?.v)?.join('');
                        concatenatedValues = concatenatedValues.replace(/\r\n/g, '');
                        let modifiedText = concatenatedValues.replace('Page #', '~~Page #');
                        sheetValue.push({ rowIndex: rowIndex, value: modifiedText });
                    } else if (cell?.ct?.s && cell?.ct?.s.length > 0 && cell?.ct?.s.length <= 1) {
                        cell.ct.s[0].v = cell.ct.s[0].v.replace(/\r\n/g, '')
                        let modifiedText = cell.ct.s[0].v.replace('Page #', '~~Page #');
                        sheetValue.push({ rowIndex: rowIndex, value: modifiedText });
                    } else if (cell?.ct?.s && cell?.ct?.s.length == 0) {
                        cell.ct.s[0].v = "";
                        let modifiedText = cell.ct.s[0].v;
                        sheetValue.push({ rowIndex: rowIndex, value: modifiedText });
                    }
                } else if (cell.hasOwnProperty('v')) {
                    cell.v = cell.v.replace(/\r\n/g, '')
                    sheetValue.push({ rowIndex: rowIndex, value: cell.v });
                }
            }
        }
        return sheetValue;
    }

    const toggleRequestEndroslmentDialog = () => {
        if (luckysheet && luckysheet != undefined) {
            const letsheetData = luckysheet.getSheetData();
            const qcData = JSON.parse(sessionStorage.getItem('inputData'));
            yesValueMapping(letsheetData, qcData)
        }
        setYesQcDialog(true);
    };

    const yesValueMapping = (sheetDat, qcData) => {
        if (!Array.isArray(sheetDat)) return;
        let flagCheck = luckysheet.getSheet().name;

        let propsData = qcData;
        let lob_Result = [];
        let uniqueLobSet = new Set();
        propsData?.forEach(table => {
            if (table?.Tablename !== 'Table 1' && !uniqueLobSet.has(table?.Tablename)) {
                lob_Result.push({
                    tableName: table?.Tablename,
                    "POLICY LOB": table?.Tablename == 'Table 2' ? 'Common Declarations' : table?.Tablename == 'Table 3' ? lobResult[0]
                        : table?.Tablename == 'Table 4' ? 'Forms Listed' : ""
                });
                uniqueLobSet.add(table.Tablename);
            }
        });
        setLobResult1(lob_Result);

        let sheetData = sheetDat;
        let csrQcRowsWithYes = [];
        for (let i = 0; i < sheetData?.length; i++) {
            let row = sheetData[i];
            for (let j = 0; j < row.length; j++) {
                let cell = row[j];
                if (cell && ((cell.m && cell.m.toLowerCase() === "yes") || (cell.v && cell.v.toLowerCase() === "yes"))) {
                    csrQcRowsWithYes.push({ rowIndex: i, rowValues: row });
                    break;
                } else if (cell && cell.ct && cell.ct.s) {
                    for (let k = 0; k < cell.ct.s.length; k++) {
                        let text = cell.ct.s[k].v.trim()
                        if (text.toLowerCase() === "yes") {
                            csrQcRowsWithYes.push({ rowIndex: i, rowValues: row });
                        }
                        break;
                    }
                }
            }
        }

        let qcValues = extractCharacterValues(csrQcRowsWithYes);
        qcValues?.forEach(f => {
            if (f.value == 'Click here') {
                f.value = ""
            }
        });

        const QcDataSetValues = [];
        let QcTempObject = [];
        let QcResult = [];
        qcValues?.forEach(item => {              // foreach Data for csrQcChecklistSheet
            if (item.value !== "No") {
                let value = item.value.trim();
                if (!QcTempObject) {
                    QcTempObject = [];
                }
                QcTempObject.push({ rowIndex: item.rowIndex, value: value });
            }
        });

        if (QcTempObject.length > 0) {
            QcDataSetValues.push(QcTempObject);
        }

        let csrQcRowIndexes = QcTempObject.map((e) => e.rowIndex);
        csrQcRowIndexes = Array.from(new Set(csrQcRowIndexes));

        csrQcRowIndexes?.forEach((f) => {
            let filteredData = QcTempObject?.filter(item => item.rowIndex === f);
            let removedData = filteredData?.filter(symbolFilter => symbolFilter.value != "+" && symbolFilter.value != "-")
            QcResult.push(removedData)
        });

        if (flagCheck == JSON.parse(sessionStorage.getItem('lob'))) {
            const mappingXRayDataFun = updateAllSheetsResultArray(QcResult, dataForXRayMapping, flagCheck);
        }

        const QcSelectedTableData = {};
        QcResult?.forEach(row => {
            if (row.length > 0) {
                let selectedIndex = row[0].rowIndex;
                let selectedTable = findTblRowAllIndex(selectedIndex, QctableColumnDetails); // headings for csrQcsheets
                if (selectedTable) {
                    if (!QcSelectedTableData[selectedTable]) {
                        QcSelectedTableData[selectedTable] = { headers: [], rows: [] };
                    }
                    let table = QctableColumnDetails[selectedTable];
                    let headerValues = Object.keys(table.columnNames);
                    QcSelectedTableData[selectedTable].headers = headerValues;
                    QcSelectedTableData[selectedTable].rows.push(row);
                }
            }
        });

        setSelctedTableData(QcSelectedTableData);
    };


    function isProposalActive() {
        setSaveFlag(false);
        try {
            const active = luckysheet?.getSheet?.();
            if (active?.name === "Proposal") {
                setSaveFlag(true);
            }
        } catch (e) {
            return false;
        }
    }

    const CsrQcEndorsementDialogComponent = (props) => {
        const dialogContentProps = {
            type: DialogType.normal,
            title: "Request Endorsement Row Item",
            subText: "",
        };

        const handleClose = () => {
            setYesQcDialog(false);
            setSelctedTableData({});
            if (props.onClose && typeof props.onClose === "function") {
                props.onClose();
            }
        };

        const handleOk = async () => {
            const sheet = luckysheet.getSheet().name;
            if (sheet == JSON.parse(sessionStorage.getItem('lob'))) {
                const dataToPush = [];
                const csrQcExportData = [];

                Object.keys(selctedTableData)?.forEach(tableName => {
                    const RowDataSet = [];
                    selctedTableData[tableName]?.rows?.forEach(row => {
                        const rowData = {};
                        selctedTableData[tableName]?.headers?.forEach((header, index) => {
                            rowData[header] = row[index] ? row[index]?.value : '';
                        });
                        RowDataSet.push(rowData);
                    });
                    dataToPush.push({ Data: RowDataSet });
                    csrQcExportData.push({ TableName: getPolicyLOB(tableName), Data: RowDataSet });
                });

                const flattenedData = dataToPush?.flatMap(item => item?.Data);
                const flattenedDataExport = csrQcExportData;
                const response = await endrolmentDialogQcCsrSaveApi(jobId, sessionStorage.getItem("csrAuthUserName") || sessionStorage.getItem("userName") || 'gokul@exdion.com', flattenedData);
                return { response, flattenedDataExport };
            }
            return { response: "error", flattenedDataExport: [] };
        };

        const endrolmentDialogQcCsrSaveApi = async (JobId, UserName, ChecklistData) => {
            document.body.classList.add('loading-indicator');
            const Token = await processAndUpdateToken(token);
            const headers = {
                'Authorization': `Bearer ${Token}`,
                "Content-Type": "application/json",
            };
            const apiUrl = `${baseUrl}/api/QuoteCompare/SaveQcAodDataByJobId`;
            try {
                const response = await axios({
                    method: "POST",
                    url: apiUrl,
                    headers: headers,
                    data: {
                        JobId: JobId,
                        UserName: UserName,
                        ChecklistData: JSON.stringify(ChecklistData),
                    }
                });
                if (response.status !== 200) {
                    return "error";
                }

                return response.data;
            } catch (error) {
                return "error";
            } finally {
                document.body.classList.remove('loading-indicator');
                return "success";
            }
        };

        const handleSaveAndExport = async () => {
            const csrQcSaveResult = await handleOk();
            if (csrQcSaveResult?.flattenedDataExport?.length > 0) {
                handleClose();
                if (csrQcSaveResult?.flattenedDataExport?.length > 0) {
                    let UserName = sessionStorage.getItem("csrAuthQcUserName") || sessionStorage.getItem("userName");

                    const exportResult = await AodExportDiscripancyData(jobId, UserName, JSON.stringify(csrQcSaveResult?.flattenedDataExport));
                    if (exportResult === "success") {
                        console.log("Export successful");
                    }
                }

            } else {
                console.error("Error saving data");
            }
        }

        const AodExportDiscripancyData = async (JobId, UserName, aodExportdata) => {
            document.body.classList.add('loading-indicator');
            const Token = await processAndUpdateToken(token);
            const headers = {
                'Authorization': `Bearer ${Token}`,
                "Accept": "*/*",
            };
            const apiUrl = `${baseUrl}/api/CSRQuoteCompare/GenerateChecklistExportExcel`;

            try {
                const response = await axios({
                    method: "POST",
                    url: apiUrl,
                    headers: headers,
                    data: {
                        "JobId": JobId,
                        "UserName": UserName,
                        "ChecklistData": aodExportdata
                    },
                    responseType: 'blob'
                });
                if (response.status !== 200) {
                    console.error('Failed to download file, status:', response.status);
                    return "error";
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${JobId}GridExcel.xlsx`);
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                console.error('Error downloading file:', error);
                return "error";
            } finally {
                document.body.classList.remove('loading-indicator');
                return "success";
            }
        };

        const modalProps = {
            isBlocking: true,
            styles: {
                main: {
                    selectors: {
                        '@media (min-width: 0px) and (max-width: 767px)': {
                            height: '200px',
                            width: '300px',
                        },
                        '@media (min-width: 768px) and (max-width: 1023px)': {
                            height: '300px',
                            width: '450px',
                        },
                        '@media (min-width: 1024px)': {
                            minWidth: '980px',
                            height: '480px'
                        },
                        '@media (min-width: 480px)': {
                            maxWidth: '660px',
                            height: '300px',
                        }
                    }
                }
            },
        };

        const getPolicyLOB = (tableName) => {
            const table = loBResult1?.find(item => item.tableName === tableName);
            return table ? (table["POLICY LOB"] || table["Policy LOB"]) : '';
        };

        function renderPositionColumn(result, index) {
            if (!result || !Array.isArray(result) || result.length <= index) return null;
            if (!QctableColumnDetails) return null;

            try {
                let selectedIndexMap = result?.map(e => e.rowIndex);
                let uniqueId = Array.from(new Set(selectedIndexMap));
                let selectedIndex = uniqueId;

                let tableRangeData = QctableColumnDetails;
                let selectedTable = findTblRowAllIndex(selectedIndex, tableRangeData);
                if (!selectedTable) return null;

                let table = QctableColumnDetails[selectedTable];
                if (!table || !table.columnNames) return null;

                let headerValues = Object.keys(table.columnNames);
                const value = result[index]?.value;
                let docIndexCheckForXRay = headerValues.indexOf("Document Viewer");

                if (docIndexCheckForXRay === index && value) {
                    return (
                        <a href={value} target="_blank" rel="noopener noreferrer"
                            style={{ display: 'block', margin: '15px 0px 0px 42px' }}>X-Ray</a>
                    );
                }
                return <div>{value}</div>;
            } catch (err) {
                console.warn("Render error:", err);
                return null;
            }
        }

        return (
            <>
                <Dialog
                    hidden={!props.isOpen}
                    onDismiss={handleClose}
                    dialogContentProps={dialogContentProps}
                    modalProps={modalProps}
                >
                    <div style={{ marginTop: '-25px', padding: '0px' }}>
                        {
                            Object.keys(selctedTableData).length > 0 ? (
                                Object.keys(selctedTableData).map((tableName, idx) => (
                                    <div key={idx} >
                                        <h3>Table - {getPolicyLOB(tableName)}</h3>
                                        <DetailsList
                                            className="custom-details-list  endroslment-tables"
                                            items={selctedTableData[tableName].rows}
                                            columns={selctedTableData[tableName].headers.map((name, index) => ({
                                                name: name,
                                                maxWidth: 250,
                                                minWidth: 250,
                                                isResizable: true,
                                                onRender: item => renderPositionColumn(item, index),
                                            }))}
                                            checkboxVisibility={CheckboxVisibility.hidden}
                                        />
                                    </div>
                                ))
                            ) : (
                                <div style={{ marginTop: '190px', textAlign: 'center' }}>
                                    <span style={{ fontSize: 'x-large' }}>No Records Found For Request Endorsement!</span>
                                </div>
                            )
                        }
                    </div>
                    <DialogFooter>
                        <DefaultButton onClick={handleClose} style={{ margin: '135px 10px 0px 0px' }} text="Close" />
                        <PrimaryButton onClick={handleOk} style={{ margin: '135px 10px 0px 0px' }} text="Save" disabled={Object.keys(selctedTableData).length === 0} />
                        <PrimaryButton onClick={handleSaveAndExport} style={{ margin: '135px 10px 0px 0px' }} text="Save & Export" disabled={Object.keys(selctedTableData).length === 0} />
                    </DialogFooter>
                </Dialog>
            </>
        );
    };

    const csrQcSaveCallAms = async (jobId, dataForSaveApi) => {
        document.body.classList.add('loading-indicator');
        const Token = await processAndUpdateToken(token);

        const headers = {
            'Authorization': `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/QuoteCompare/UpdateQCDataByJobId`;
        try {
            const response = await axios({
                method: "PUT",
                url: apiUrl,
                headers: headers,
                data: {
                    data: dataForSaveApi,
                    JobId: jobId
                }
            });
            if (response.status !== 200) {
                return "error";
            }

            return response.data;
        } catch (error) {
            return "error";
        } finally {
            document.body.classList.remove('loading-indicator');
            return "success";
        }
    };

    const onCsrQcSaveClick = async () => {
        try {
            luckysheet.exitEditMode();
            const Sheet = luckysheet.getSheet();
            const policyData = Sheet?.data;

            const processData = (sheetData, tblRangeArray, filterData) => {
                let aodDataMSet = [];

                if (sheetData && sheetData?.length > 0 && tblRangeArray && tblRangeArray?.length > 0) {
                    tblRangeArray?.forEach((f) => {
                        const tableFilterData = filterData?.find((d) => d.TableName === f?.TableName);
                        if (tableFilterData) {
                            const filteredOriginalData = tableFilterData?.data;
                            const start = f?.range?.start + 2;
                            const end = f?.range?.end + 1;
                            const splitedData = sheetData.slice(start, end);
                            if (splitedData && splitedData?.length > 0) {
                                let aodDataSet = [];
                                splitedData?.forEach((item, itemIndex) => {
                                    let record = filteredOriginalData?.find((fod) => fod?.sheetPosition && fod?.sheetPosition === (start + itemIndex));
                                    const aod = item[f?.columnNames["Actions on Discrepancy"]] || item[f?.columnNames["ActionOnDiscrepancy"]] || item[f?.columnNames[0]?.indexOf("ActionOnDiscrepancy") - 1];
                                    const re = item[f?.columnNames["Request Endorsement"]] || item[f?.columnNames["RequestEndorsement"]] || item[f?.columnNames[0]?.indexOf("RequestEndorsement") - 1];
                                    const ns = item[f?.columnNames["Notes for Endorsement"]] || item[f?.columnNames["Notes"]] || item[f?.columnNames[0]?.indexOf("Notes") - 1];
                                    const nff = item[f?.columnNames["Notes(Free Fill)"]] || item[f?.columnNames["NotesFreeFill"]] || item[f?.columnNames[0]?.indexOf("NotesFreeFill") - 1];

                                    let aodData = aod ? getText(aod, true) : '';
                                    let reData = re ? getText(re, true) : '';
                                    let nsData = ns ? getText(ns, true) : '';
                                    let nffData = nff ? getText(nff, true) : '';

                                    aodData = aodData != undefined && aodData != null ? aodData : '';
                                    reData = reData != undefined && reData != null ? reData : '';
                                    nsData = nsData != undefined && nsData != null ? nsData : '';
                                    nffData = nffData != undefined && nffData != null ? nffData : '';

                                    if (record && !(aodData?.trim() === '' && reData?.trim() === '' && nsData?.trim() === '' && nffData?.trim() === '')) {
                                        record["ActionOnDiscrepancy"] = aodData;
                                        record["RequestEndorsement"] = reData;
                                        record["Notes"] = nsData;
                                        record["NotesFreeFill"] = nffData;
                                        if (record["ActionOnDiscrepancy"] === "Click here" && record["RequestEndorsement"] === "Click here" &&
                                            record["Notes"] === "Click here") {
                                            record["ActionOnDiscrepancy"] = "";
                                            record["RequestEndorsement"] = "";
                                            record["Notes"] = "";
                                        } else {
                                            ["ActionOnDiscrepancy", "RequestEndorsement", "Notes"]?.forEach(key => {
                                                if (record[key] === "Click here") {
                                                    record[key] = "";
                                                }
                                            })
                                        }

                                        const mappedRecord = {
                                            Id: record?.Id,
                                            ActionOnDiscrepancy: aodData === "Click here" ? "" : aodData,
                                            RequestEndorsement: reData === "Click here" ? "" : reData,
                                            Notes: nsData === "Click here" ? "" : nsData,
                                            NotesFreeFill: nffData
                                        };
                                        aodDataSet.push(mappedRecord);
                                    }
                                });
                                if (aodDataSet?.length > 0) {
                                    aodDataMSet.push({ "Data": aodDataSet });
                                }
                            }
                        }
                    });
                }
                return aodDataMSet;
            };
            let checklistData = [];
            const csrQctrack = sessionStorage.getItem('csrQcDataTracked')
            const data = csrQcDataForSave == null || undefined || csrQcDataForSave.length == 0 ? JSON.parse(csrQctrack) : csrQcDataForSave;
            const reseededData = data?.map((item, index) => {
                return {
                    ...item,
                    TableName: `Table ${index + 2}`
                };
            });
            const positionCsrQc = sessionStorage.getItem('positioningForCsrQc')
            const csrQcPosDetails = dataForSaveCsrQcPosition == null || undefined || dataForSaveCsrQcPosition?.length == 0 ? JSON.parse(positionCsrQc) : dataForSaveCsrQcPosition;
            const reseededCsrQcPosDetails = csrQcPosDetails?.map((item, index) => {
                return {
                    ...item,
                    TableName: `Table ${index + 2}`
                };
            });

            const sheetData = policyData;
            checklistData = processData(sheetData, reseededCsrQcPosDetails, reseededData);

            let checklistDataForUpdate = checklistData?.filter(f => f?.Data && f.Data?.length > 0);
            const flattenedData = checklistDataForUpdate.flatMap(item => item.Data);
            await csrQcSaveCallAms(jobId, flattenedData);
        } catch (error) {
            return error;
        }
    };

    const generateExcelData = (isExport, sheetName, jobId, callback) => {
        let flagCheck = sheetName;
        const propsData = luckysheet.getAllSheets()?.filter(f => f.name.includes(flagCheck))[0].data;
        const keys = Object.keys(proposaltableColumnDetails);
        const findTable = [];
        let policySheetData = [];
        let headerSpilttedArray = [];
        let tableDataSetArray = [];

        if (flagCheck == "Proposal") {
            if (keys?.length > 0 && propsData && propsData != undefined) {
                keys?.forEach((f) => {
                    const tableData = proposaltableColumnDetails[f];
                    if (tableData && tableData?.range && tableData?.range?.start != undefined && tableData?.range?.end != undefined && tableData?.columnNames && tableData?.range?.end != '') {
                        let slicedData = propsData?.slice(f === "PTable 2" ? tableData?.range?.start : tableData?.range?.start, tableData?.range?.end + 1);
                        if (f == 'PTable 1') {
                            slicedData = slicedData?.slice(3);
                            slicedData = slicedData?.map(sublist => sublist?.filter(item => item !== null));
                        }
                        findTable.push(slicedData);
                    }
                });
            }

            findTable?.map((e, index) => {
                if (index > 0) {
                    let tblIndex = [];
                    let tblColumnName = [];
                    let hasReachedLimit = false;

                    const data = index === 1 ? e[0] : e[1]
                    data?.map((e1, index1) => {
                        if (e1 != null) {
                            if (index1 > 0 && !hasReachedLimit) {
                                tblIndex.push(index1);
                                tblColumnName.push(e1?.m || e1?.v);
                            }

                            if (index === 3 && e[0][1]?.m === "Details not available") {
                                headerSpilttedArray.push({
                                    "Table": "Table 5",
                                    "index": tblIndex,
                                    "tblColumnName": tblColumnName
                                });
                            } else {
                                headerSpilttedArray.push({
                                    "Table": `Table ${index + 1}`, index: tblIndex, tblColumnName
                                });
                            }
                        }
                    });
                }
                headerSpilttedArray?.forEach(table => {
                    const tableNumber = parseInt(table?.Table?.split(" ")[1]);
                    if (tableNumber >= 2) {
                        table.tblColumnName[0] = "Coverage Specifications";
                    }
                });
            });

            const uniqueArray = [...new Map(headerSpilttedArray?.map(item => [item.Table, item])).values()];

            findTable?.map((f, index) => {
                if (index > 0) {
                    let keyValuePair = [];
                    f?.map((e, index1) => {
                        if (index === 1 ? index1 > 0 : index1 > 1) {
                            let tableValueMap = uniqueArray[index - 1];
                            if (tableValueMap) {
                                let object = {};
                                tableValueMap.index.map((i, index2) => {
                                    if (e[i]?.ct?.s && Array.isArray(e[i]?.ct?.s)) {
                                        let arrayS = e[i]?.ct?.s.filter((f) => f != null);
                                        let concatenatedValues = arrayS?.map(item => item?.v)?.join('');
                                        concatenatedValues = concatenatedValues?.replace(/\r\n/g, '~~');
                                        const finalValue = e[i]?.m || e[i]?.v || concatenatedValues;
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = finalValue;
                                    } else {
                                        object[`${tableValueMap?.tblColumnName[index2]}`] = e[i]?.m || e[i]?.v || e[i]?.ct?.s;
                                    }
                                    if (tableValueMap.index?.length == index2 + 1) {
                                        keyValuePair.push(object);
                                    }
                                })
                            }
                        }
                        if (f?.length == index1 + 1) {
                            tableDataSetArray.push({ "TableName": uniqueArray[index - 1]?.Table, Data: keyValuePair });
                        }
                    });
                }
            });
        }
        policySheetData.push(tableDataSetArray);

        if (findTable && findTable?.length > 0) {
            const result = findTable[0]?.map(([index1, index2]) => ({
                index1,
                index2,
            }));
            const csrTable1Data = [];
            for (let row in result) {
                const cellData = result[row];

                const cell1Text = cellData.index1?.v || cellData.index1?.ct || '';
                const cell2Text = cellData.index2?.v !== undefined ? (cellData.index2.v || cellData.index2?.ct) : (cellData.index2?.ct?.fa === "@" ? "" : cellData.index2?.ct?.fa);

                if (cell1Text && cell1Text.s && cell1Text.s.length > 0 && cell2Text || cell1Text) {
                    const headerValue = Array.isArray(cell1Text.s) ? cell1Text.s.map(item => item.v || '').join(',') : cell1Text;
                    const concatenatedValues = Array.isArray(cell2Text.s) ? cell2Text.s.map(item => item.v).join('') : cell2Text;

                    const objStructure = {
                        HeaderID: row,
                        JOBID: jobId,
                        'Policy LOB': JSON.parse(sessionStorage.getItem('lob')),
                        Headers: headerValue,
                        '(No column name)': concatenatedValues,
                    }

                    csrTable1Data.push(objStructure);
                }
            }

            const transformedJson = [
                {
                    "TableName": "Table 1",
                    "CustomLab": "",
                    "Type": "info",
                    "Data": csrTable1Data
                }
            ];
            const findingTable2Index = policySheetData[0]?.findIndex(table => table.TableName === "Table 2")

            if (findingTable2Index !== -1) {
                policySheetData[0]?.splice(findingTable2Index, 0, transformedJson[0]);
            }
        }

        if (isExport == true) {
            const sheetDatas = policySheetData[0];

            const modifiedTabledata = sheetDatas?.map(item => ({
                "TableName": item?.TableName,
                "CustomLab": item?.TableName === "Table 2" ? "Common Declaration" : item?.TableName === "Table 3" ? JSON.parse(sessionStorage.getItem('lob'))
                    : item?.TableName === "Table 4" ? "Forms Listed" : item?.TableName === "Table 5" ? "Details not avaliable" : "",
                "Type": item?.TableName === "Table 1" ? "info" : "table",
                "Data": item.Data
            }));

            const dataFromOnUpdateClick = modifiedTabledata;

            if (typeof callback === "function") {
                callback(dataFromOnUpdateClick);
            }
        }
    };

    const ExportClick = async (jobId) => {
        const mergedData = [];
        let sheetnames = []
        let flagcheck = luckysheet.getAllSheets();

        for (let i = 0; i < flagcheck.length; i++) {
            sheetnames.push(flagcheck[i].name);
        }

        if (sheetnames?.includes("Proposal")) {
            generateExcelData(true, "Proposal", jobId, (dataFromOnUpdateClick) => {
                const Tabledata1 = dataFromOnUpdateClick;
                mergedData.push(...Tabledata1);
            });
        }

        const formTableDataJson = JSON.stringify(mergedData);

        const payload = {
            "JobId": jobId,
            "JobSheetName": JSON.parse(sessionStorage.getItem('lob')),
            "SheetList": mergedData.length > 0
                ? [
                    {
                        "SheetName": "Proposal",
                        "DisclaimerLab": Disclaimer,
                        "Title": JSON.parse(sessionStorage.getItem('lob')),
                        "ProposalData": formTableDataJson
                    }
                ]
                : []
        };


        await ExportExcelCsrQc(payload);
    };

    const ExportExcelCsrQc = async (data) => {
        try {
            document.body.classList.add('loading-indicator');
            const Token = await processAndUpdateToken(token);
            const headers = {
                'Authorization': `Bearer ${Token}`,
                "Accept": "*/*",
            };

            const apiUrl = `${baseUrl}/api/CSRQuoteCompare/QuoteExportExcel`;

            const response = await axios.post(apiUrl, data, {
                headers,
                responseType: 'blob',
            });

            if (response.status !== 200) {
                return "error";
            }

            const checklistFilenameFromHeader = response.headers['x-checklist-filename'];
            const checklistFileName = checklistFilenameFromHeader
                ? `${checklistFilenameFromHeader}.xlsx`
                : `${jobId}_ChecklistData.xlsx`;

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', checklistFileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

            return "success";
        }
        catch (error) {
            console.error("ChecklistGenrator error", error);
            return "error";
        } finally {
            document.body.classList.remove("loading-indicator");
        }
    };

    const UpdateQcStatusButton = async (type) => {
        try {
            document.body.classList.add('loading-indicator');

            const currentReviewStatus = reviewData?.ReviewCompleted || false;
            const currentSendInsuredStatus = sendPolicyInsuredData?.SendPolicyToInsured || false;

            let data = {
                ReviewCompleted: type === "review" ? true : currentReviewStatus,
                SendPolicyToInsured: type === "insured" ? true : currentSendInsuredStatus,
                UserEmail: "gokul_n@exdion.com",
                JobId: jobId
            }

            const response = await UpdateQcStatusCall(data, token);
            await getCsrReviewData(jobId);
            container.current.showSnackbar('Status updated successfully', "success", true);
        } catch (error) {
            console.error("ChecklistGenrator error", error);
            return "error";
        } finally {
            document.body.classList.remove("loading-indicator");
        }
    }

    const getCsrReviewData = async (jobId) => {
        try {
            let token = sessionStorage.getItem("token");
            token = await processAndUpdateToken(token);
            const response = await axios.get(
                baseUrl + `/api/QuoteCompare/GetQCDataByJobId?JobId=${jobId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response?.data) {
                setReviewData(response?.data);
                setSendPolicyInsuredData(response?.data);
            } else {
                setReviewData([]);
                setSendPolicyInsuredData([]);
            }
        } catch (error) {
            setReviewData([]);
            setSendPolicyInsuredData([]);
        }
    }

    return (
        <>
            <div>
                <div >
                    <div style={{ display: 'flex' }}>
                        <PrimaryButton
                            onClick={() => {
                                if (!saveFlag) {
                                    onCsrQcSaveClick(true, false);
                                }
                            }}
                            disabled={saveFlag}
                            style={{
                                backgroundColor: saveFlag ? '#d3d3d3' : 'lightblue', // greyed when disabled
                                opacity: saveFlag ? 0.6 : 1,                        // dim when disabled
                                height: '24px',
                                borderRadius: '20px',
                                borderColor: 'black',
                                fontSize: '10px',
                                margin: '8px',
                                color: saveFlag ? 'gray' : 'black',                 // text color change
                                cursor: saveFlag ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Save
                        </PrimaryButton>

                        <PrimaryButton
                            onClick={() => {
                                // onCsrQcSaveClick();
                                ExportClick(jobId);
                            }}
                            style={{
                                backgroundColor: 'lightblue', height: '24px', borderRadius: '20px',
                                borderColor: 'black', fontSize: '10px', margin: '8px 8px 8px 8px', color: 'black'
                            }}
                        >Export Checklist</PrimaryButton>
                        {/* <PrimaryButton onClick={() => toggleRequestEndroslmentDialog()} style={{
                            backgroundColor: 'lightblue', height: '24px', borderRadius: '20px',
                            borderColor: 'black', fontSize: '10px', margin: '8px 8px 8px 8px', color: 'black'
                        }}>Generate Endorsement Template</PrimaryButton>
                        <PrimaryButton onClick={() => UpdateQcStatusButton("review")} style={{
                            backgroundColor: isPreviewCompleted ? '#72d17db8' : 'lightblue', height: '24px', borderRadius: '20px',
                            borderColor: 'black', fontSize: '10px', margin: '8px 8px 8px 8px', color: 'black'
                        }}>Review Completed</PrimaryButton>
                        <PrimaryButton onClick={() => UpdateQcStatusButton("insured")} style={{
                            backgroundColor: isGridspiCompleted ? '#72d17db8' : 'lightblue', height: '24px', borderRadius: '20px',
                            borderColor: 'black', fontSize: '10px', margin: '8px 8px 8px 8px', color: 'black'
                        }}>Send Policy To Insured</PrimaryButton> */}
                    </div>

                    {yesQcDialog && (
                        <CsrQcEndorsementDialogComponent
                            isOpen={yesQcDialog}
                            onClose={() => setYesQcDialog(false)}
                        />
                    )}

                    {dropDialog && < DiscrepancyOptionsDialogComponent isOpen={dropDialog} luckySheet={luckysheet} onClose={(e) => funForDiscrepancyCol(e)} message={"Action On Descrepancy (from AMs)"} />}
                    {openFilterDialog && <FilterCsrDialogComponent isOpen={{ openFilterDialog, QctableColumnDetails, luckysheet, filterSelectionData }} onClose={(e) => handleFilterDialogClose(e)} />}
                    {/* {openDialog && (<DialogComponent isOpen={openDialog} onClose={handleDialogClose} message={msgText} />)}*/}
                </div>
                <div style={{ position: 'relative' }}>
                    {typeof luckysheet !== "undefined" && showFilter && (
                        <>
                            <Icon
                                iconName="Filter"
                                onClick={handleIconClick}
                                style={{
                                    position: 'absolute',
                                    top: '2px',
                                    right: '190px',
                                    fontSize: '16.2px',
                                    margin: '5px',
                                    zIndex: 10,
                                    cursor: 'pointer'
                                }}
                            />
                            <h6
                                onClick={handleIconClick}
                                style={{
                                    position: 'absolute',
                                    top: '4px',
                                    fontWeight: 500,
                                    right: '155px',
                                    fontSize: '12.5px',
                                    margin: '5px',
                                    zIndex: 10,
                                    cursor: 'pointer'
                                }}
                            >
                                Filter
                            </h6>
                        </>
                    )}
                    <div className="csrQCSheet" id="luckysheet" ref={luckyCss}></div>
                </div>
                <SimpleSnackbar ref={container} />
            </div></>
    );
}
